function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

(function (t, e) {
  "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" === (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" === typeof define && define.amd ? define([], e) : "object" === (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-tel-input"] = e() : t["vue-tel-input"] = e();
})("undefined" !== typeof self ? self : this, function () {
  return function () {
    var t = {
      7679: function _(t, e) {
        var n, r, d;

        (function (i, o) {
          r = [], n = o, d = "function" === typeof n ? n.apply(e, r) : n, void 0 === d || (t.exports = d);
        })("undefined" !== typeof self && self, function () {
          function t() {
            var e = Object.getOwnPropertyDescriptor(document, "currentScript");
            if (!e && "currentScript" in document && document.currentScript) return document.currentScript;
            if (e && e.get !== t && document.currentScript) return document.currentScript;

            try {
              throw new Error();
            } catch (f) {
              var n,
                  r,
                  d,
                  i = /.*at [^(]*\((.*):(.+):(.+)\)$/gi,
                  o = /@([^@]*):(\d+):(\d+)\s*$/gi,
                  a = i.exec(f.stack) || o.exec(f.stack),
                  u = a && a[1] || !1,
                  $ = a && a[2] || !1,
                  c = document.location.href.replace(document.location.hash, ""),
                  s = document.getElementsByTagName("script");
              u === c && (n = document.documentElement.outerHTML, r = new RegExp("(?:[^\\n]+?\\n){0," + ($ - 2) + "}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*", "i"), d = n.replace(r, "$1").trim());

              for (var l = 0; l < s.length; l++) {
                if ("interactive" === s[l].readyState) return s[l];
                if (s[l].src === u) return s[l];
                if (u === c && s[l].innerHTML && s[l].innerHTML.trim() === d) return s[l];
              }

              return null;
            }
          }

          return t;
        });
      },
      3099: function _(t) {
        t.exports = function (t) {
          if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
          return t;
        };
      },
      6077: function _(t, e, n) {
        var r = n(111);

        t.exports = function (t) {
          if (!r(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
          return t;
        };
      },
      1223: function _(t, e, n) {
        var r = n(5112),
            d = n(30),
            i = n(3070),
            o = r("unscopables"),
            a = Array.prototype;
        void 0 == a[o] && i.f(a, o, {
          configurable: !0,
          value: d(null)
        }), t.exports = function (t) {
          a[o][t] = !0;
        };
      },
      1530: function _(t, e, n) {
        "use strict";

        var r = n(8710).charAt;

        t.exports = function (t, e, n) {
          return e + (n ? r(t, e).length : 1);
        };
      },
      5787: function _(t) {
        t.exports = function (t, e, n) {
          if (!(t instanceof e)) throw TypeError("Incorrect " + (n ? n + " " : "") + "invocation");
          return t;
        };
      },
      9670: function _(t, e, n) {
        var r = n(111);

        t.exports = function (t) {
          if (!r(t)) throw TypeError(String(t) + " is not an object");
          return t;
        };
      },
      8533: function _(t, e, n) {
        "use strict";

        var r = n(2092).forEach,
            d = n(9341),
            i = d("forEach");
        t.exports = i ? [].forEach : function (t) {
          return r(this, t, arguments.length > 1 ? arguments[1] : void 0);
        };
      },
      8457: function _(t, e, n) {
        "use strict";

        var r = n(9974),
            d = n(7908),
            i = n(3411),
            o = n(7659),
            a = n(7466),
            u = n(6135),
            $ = n(1246);

        t.exports = function (t) {
          var e,
              n,
              c,
              s,
              l,
              f,
              p = d(t),
              h = "function" == typeof this ? this : Array,
              v = arguments.length,
              y = v > 1 ? arguments[1] : void 0,
              g = void 0 !== y,
              m = $(p),
              b = 0;
          if (g && (y = r(y, v > 2 ? arguments[2] : void 0, 2)), void 0 == m || h == Array && o(m)) for (e = a(p.length), n = new h(e); e > b; b++) {
            f = g ? y(p[b], b) : p[b], u(n, b, f);
          } else for (s = m.call(p), l = s.next, n = new h(); !(c = l.call(s)).done; b++) {
            f = g ? i(s, y, [c.value, b], !0) : c.value, u(n, b, f);
          }
          return n.length = b, n;
        };
      },
      1318: function _(t, e, n) {
        var r = n(5656),
            d = n(7466),
            i = n(1400),
            o = function o(t) {
          return function (e, n, o) {
            var a,
                u = r(e),
                $ = d(u.length),
                c = i(o, $);

            if (t && n != n) {
              while ($ > c) {
                if (a = u[c++], a != a) return !0;
              }
            } else for (; $ > c; c++) {
              if ((t || c in u) && u[c] === n) return t || c || 0;
            }

            return !t && -1;
          };
        };

        t.exports = {
          includes: o(!0),
          indexOf: o(!1)
        };
      },
      2092: function _(t, e, n) {
        var r = n(9974),
            d = n(8361),
            i = n(7908),
            o = n(7466),
            a = n(5417),
            u = [].push,
            $ = function $(t) {
          var e = 1 == t,
              n = 2 == t,
              $ = 3 == t,
              c = 4 == t,
              s = 6 == t,
              l = 7 == t,
              f = 5 == t || s;
          return function (p, h, v, y) {
            for (var g, m, b = i(p), C = d(b), x = r(h, v, 3), O = o(C.length), w = 0, S = y || a, E = e ? S(p, O) : n || l ? S(p, 0) : void 0; O > w; w++) {
              if ((f || w in C) && (g = C[w], m = x(g, w, b), t)) if (e) E[w] = m;else if (m) switch (t) {
                case 3:
                  return !0;

                case 5:
                  return g;

                case 6:
                  return w;

                case 2:
                  u.call(E, g);
              } else switch (t) {
                case 4:
                  return !1;

                case 7:
                  u.call(E, g);
              }
            }

            return s ? -1 : $ || c ? c : E;
          };
        };

        t.exports = {
          forEach: $(0),
          map: $(1),
          filter: $(2),
          some: $(3),
          every: $(4),
          find: $(5),
          findIndex: $(6),
          filterOut: $(7)
        };
      },
      1194: function _(t, e, n) {
        var r = n(7293),
            d = n(5112),
            i = n(7392),
            o = d("species");

        t.exports = function (t) {
          return i >= 51 || !r(function () {
            var e = [],
                n = e.constructor = {};
            return n[o] = function () {
              return {
                foo: 1
              };
            }, 1 !== e[t](Boolean).foo;
          });
        };
      },
      9341: function _(t, e, n) {
        "use strict";

        var r = n(7293);

        t.exports = function (t, e) {
          var n = [][t];
          return !!n && r(function () {
            n.call(null, e || function () {
              throw 1;
            }, 1);
          });
        };
      },
      5417: function _(t, e, n) {
        var r = n(111),
            d = n(3157),
            i = n(5112),
            o = i("species");

        t.exports = function (t, e) {
          var n;
          return d(t) && (n = t.constructor, "function" != typeof n || n !== Array && !d(n.prototype) ? r(n) && (n = n[o], null === n && (n = void 0)) : n = void 0), new (void 0 === n ? Array : n)(0 === e ? 0 : e);
        };
      },
      3411: function _(t, e, n) {
        var r = n(9670),
            d = n(9212);

        t.exports = function (t, e, n, i) {
          try {
            return i ? e(r(n)[0], n[1]) : e(n);
          } catch (o) {
            throw d(t), o;
          }
        };
      },
      7072: function _(t, e, n) {
        var r = n(5112),
            d = r("iterator"),
            i = !1;

        try {
          var o = 0,
              a = {
            next: function next() {
              return {
                done: !!o++
              };
            },
            return: function _return() {
              i = !0;
            }
          };
          a[d] = function () {
            return this;
          }, Array.from(a, function () {
            throw 2;
          });
        } catch (u) {}

        t.exports = function (t, e) {
          if (!e && !i) return !1;
          var n = !1;

          try {
            var r = {};
            r[d] = function () {
              return {
                next: function next() {
                  return {
                    done: n = !0
                  };
                }
              };
            }, t(r);
          } catch (u) {}

          return n;
        };
      },
      4326: function _(t) {
        var e = {}.toString;

        t.exports = function (t) {
          return e.call(t).slice(8, -1);
        };
      },
      648: function _(t, e, n) {
        var r = n(1694),
            d = n(4326),
            i = n(5112),
            o = i("toStringTag"),
            a = "Arguments" == d(function () {
          return arguments;
        }()),
            u = function u(t, e) {
          try {
            return t[e];
          } catch (n) {}
        };

        t.exports = r ? d : function (t) {
          var e, n, r;
          return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = u(e = Object(t), o)) ? n : a ? d(e) : "Object" == (r = d(e)) && "function" == typeof e.callee ? "Arguments" : r;
        };
      },
      9920: function _(t, e, n) {
        var r = n(6656),
            d = n(3887),
            i = n(1236),
            o = n(3070);

        t.exports = function (t, e) {
          for (var n = d(e), a = o.f, u = i.f, $ = 0; $ < n.length; $++) {
            var c = n[$];
            r(t, c) || a(t, c, u(e, c));
          }
        };
      },
      4964: function _(t, e, n) {
        var r = n(5112),
            d = r("match");

        t.exports = function (t) {
          var e = /./;

          try {
            "/./"[t](e);
          } catch (n) {
            try {
              return e[d] = !1, "/./"[t](e);
            } catch (r) {}
          }

          return !1;
        };
      },
      8544: function _(t, e, n) {
        var r = n(7293);
        t.exports = !r(function () {
          function t() {}

          return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
        });
      },
      4994: function _(t, e, n) {
        "use strict";

        var r = n(3383).IteratorPrototype,
            d = n(30),
            i = n(9114),
            o = n(8003),
            a = n(7497),
            u = function u() {
          return this;
        };

        t.exports = function (t, e, n) {
          var $ = e + " Iterator";
          return t.prototype = d(r, {
            next: i(1, n)
          }), o(t, $, !1, !0), a[$] = u, t;
        };
      },
      8880: function _(t, e, n) {
        var r = n(9781),
            d = n(3070),
            i = n(9114);
        t.exports = r ? function (t, e, n) {
          return d.f(t, e, i(1, n));
        } : function (t, e, n) {
          return t[e] = n, t;
        };
      },
      9114: function _(t) {
        t.exports = function (t, e) {
          return {
            enumerable: !(1 & t),
            configurable: !(2 & t),
            writable: !(4 & t),
            value: e
          };
        };
      },
      6135: function _(t, e, n) {
        "use strict";

        var r = n(7593),
            d = n(3070),
            i = n(9114);

        t.exports = function (t, e, n) {
          var o = r(e);
          o in t ? d.f(t, o, i(0, n)) : t[o] = n;
        };
      },
      654: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(4994),
            i = n(9518),
            o = n(7674),
            a = n(8003),
            u = n(8880),
            $ = n(1320),
            c = n(5112),
            s = n(1913),
            l = n(7497),
            f = n(3383),
            p = f.IteratorPrototype,
            h = f.BUGGY_SAFARI_ITERATORS,
            v = c("iterator"),
            y = "keys",
            g = "values",
            m = "entries",
            b = function b() {
          return this;
        };

        t.exports = function (t, e, n, c, f, C, x) {
          d(n, e, c);

          var O,
              w,
              S,
              E = function E(t) {
            if (t === f && T) return T;
            if (!h && t in N) return N[t];

            switch (t) {
              case y:
                return function () {
                  return new n(this, t);
                };

              case g:
                return function () {
                  return new n(this, t);
                };

              case m:
                return function () {
                  return new n(this, t);
                };
            }

            return function () {
              return new n(this);
            };
          },
              P = e + " Iterator",
              I = !1,
              N = t.prototype,
              k = N[v] || N["@@iterator"] || f && N[f],
              T = !h && k || E(f),
              A = "Array" == e && N.entries || k;

          if (A && (O = i(A.call(new t())), p !== Object.prototype && O.next && (s || i(O) === p || (o ? o(O, p) : "function" != typeof O[v] && u(O, v, b)), a(O, P, !0, !0), s && (l[P] = b))), f == g && k && k.name !== g && (I = !0, T = function T() {
            return k.call(this);
          }), s && !x || N[v] === T || u(N, v, T), l[e] = T, f) if (w = {
            values: E(g),
            keys: C ? T : E(y),
            entries: E(m)
          }, x) for (S in w) {
            (h || I || !(S in N)) && $(N, S, w[S]);
          } else r({
            target: e,
            proto: !0,
            forced: h || I
          }, w);
          return w;
        };
      },
      7235: function _(t, e, n) {
        var r = n(857),
            d = n(6656),
            i = n(6061),
            o = n(3070).f;

        t.exports = function (t) {
          var e = r.Symbol || (r.Symbol = {});
          d(e, t) || o(e, t, {
            value: i.f(t)
          });
        };
      },
      9781: function _(t, e, n) {
        var r = n(7293);
        t.exports = !r(function () {
          return 7 != Object.defineProperty({}, 1, {
            get: function get() {
              return 7;
            }
          })[1];
        });
      },
      317: function _(t, e, n) {
        var r = n(7854),
            d = n(111),
            i = r.document,
            o = d(i) && d(i.createElement);

        t.exports = function (t) {
          return o ? i.createElement(t) : {};
        };
      },
      8324: function _(t) {
        t.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0
        };
      },
      7871: function _(t) {
        t.exports = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window));
      },
      6833: function _(t, e, n) {
        var r = n(8113);
        t.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(r);
      },
      5268: function _(t, e, n) {
        var r = n(4326),
            d = n(7854);
        t.exports = "process" == r(d.process);
      },
      1036: function _(t, e, n) {
        var r = n(8113);
        t.exports = /web0s(?!.*chrome)/i.test(r);
      },
      8113: function _(t, e, n) {
        var r = n(5005);
        t.exports = r("navigator", "userAgent") || "";
      },
      7392: function _(t, e, n) {
        var r,
            d,
            i = n(7854),
            o = n(8113),
            a = i.process,
            u = a && a.versions,
            $ = u && u.v8;
        $ ? (r = $.split("."), d = r[0] < 4 ? 1 : r[0] + r[1]) : o && (r = o.match(/Edge\/(\d+)/), (!r || r[1] >= 74) && (r = o.match(/Chrome\/(\d+)/), r && (d = r[1]))), t.exports = d && +d;
      },
      748: function _(t) {
        t.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
      },
      2109: function _(t, e, n) {
        var r = n(7854),
            d = n(1236).f,
            i = n(8880),
            o = n(1320),
            a = n(3505),
            u = n(9920),
            $ = n(4705);

        t.exports = function (t, e) {
          var n,
              c,
              s,
              l,
              f,
              p,
              h = t.target,
              v = t.global,
              y = t.stat;
          if (c = v ? r : y ? r[h] || a(h, {}) : (r[h] || {}).prototype, c) for (s in e) {
            if (f = e[s], t.noTargetGet ? (p = d(c, s), l = p && p.value) : l = c[s], n = $(v ? s : h + (y ? "." : "#") + s, t.forced), !n && void 0 !== l) {
              if (_typeof(f) === _typeof(l)) continue;
              u(f, l);
            }

            (t.sham || l && l.sham) && i(f, "sham", !0), o(c, s, f, t);
          }
        };
      },
      7293: function _(t) {
        t.exports = function (t) {
          try {
            return !!t();
          } catch (e) {
            return !0;
          }
        };
      },
      7007: function _(t, e, n) {
        "use strict";

        n(4916);

        var r = n(1320),
            d = n(2261),
            i = n(7293),
            o = n(5112),
            a = n(8880),
            u = o("species"),
            $ = RegExp.prototype,
            c = !i(function () {
          var t = /./;
          return t.exec = function () {
            var t = [];
            return t.groups = {
              a: "7"
            }, t;
          }, "7" !== "".replace(t, "$<a>");
        }),
            s = function () {
          return "$0" === "a".replace(/./, "$0");
        }(),
            l = o("replace"),
            f = function () {
          return !!/./[l] && "" === /./[l]("a", "$0");
        }(),
            p = !i(function () {
          var t = /(?:)/,
              e = t.exec;

          t.exec = function () {
            return e.apply(this, arguments);
          };

          var n = "ab".split(t);
          return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
        });

        t.exports = function (t, e, n, l) {
          var h = o(t),
              v = !i(function () {
            var e = {};
            return e[h] = function () {
              return 7;
            }, 7 != ""[t](e);
          }),
              y = v && !i(function () {
            var e = !1,
                n = /a/;
            return "split" === t && (n = {}, n.constructor = {}, n.constructor[u] = function () {
              return n;
            }, n.flags = "", n[h] = /./[h]), n.exec = function () {
              return e = !0, null;
            }, n[h](""), !e;
          });

          if (!v || !y || "replace" === t && (!c || !s || f) || "split" === t && !p) {
            var g = /./[h],
                m = n(h, ""[t], function (t, e, n, r, i) {
              var o = e.exec;
              return o === d || o === $.exec ? v && !i ? {
                done: !0,
                value: g.call(e, n, r)
              } : {
                done: !0,
                value: t.call(n, e, r)
              } : {
                done: !1
              };
            }, {
              REPLACE_KEEPS_$0: s,
              REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: f
            }),
                b = m[0],
                C = m[1];
            r(String.prototype, t, b), r($, h, 2 == e ? function (t, e) {
              return C.call(t, this, e);
            } : function (t) {
              return C.call(t, this);
            });
          }

          l && a($[h], "sham", !0);
        };
      },
      9974: function _(t, e, n) {
        var r = n(3099);

        t.exports = function (t, e, n) {
          if (r(t), void 0 === e) return t;

          switch (n) {
            case 0:
              return function () {
                return t.call(e);
              };

            case 1:
              return function (n) {
                return t.call(e, n);
              };

            case 2:
              return function (n, r) {
                return t.call(e, n, r);
              };

            case 3:
              return function (n, r, d) {
                return t.call(e, n, r, d);
              };
          }

          return function () {
            return t.apply(e, arguments);
          };
        };
      },
      5005: function _(t, e, n) {
        var r = n(857),
            d = n(7854),
            i = function i(t) {
          return "function" == typeof t ? t : void 0;
        };

        t.exports = function (t, e) {
          return arguments.length < 2 ? i(r[t]) || i(d[t]) : r[t] && r[t][e] || d[t] && d[t][e];
        };
      },
      1246: function _(t, e, n) {
        var r = n(648),
            d = n(7497),
            i = n(5112),
            o = i("iterator");

        t.exports = function (t) {
          if (void 0 != t) return t[o] || t["@@iterator"] || d[r(t)];
        };
      },
      7854: function _(t, e, n) {
        var r = function r(t) {
          return t && t.Math == Math && t;
        };

        t.exports = r("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) && globalThis) || r("object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window) || r("object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self) || r("object" == _typeof(n.g) && n.g) || function () {
          return this;
        }() || Function("return this")();
      },
      6656: function _(t, e, n) {
        var r = n(7908),
            d = {}.hasOwnProperty;

        t.exports = Object.hasOwn || function (t, e) {
          return d.call(r(t), e);
        };
      },
      3501: function _(t) {
        t.exports = {};
      },
      842: function _(t, e, n) {
        var r = n(7854);

        t.exports = function (t, e) {
          var n = r.console;
          n && n.error && (1 === arguments.length ? n.error(t) : n.error(t, e));
        };
      },
      490: function _(t, e, n) {
        var r = n(5005);
        t.exports = r("document", "documentElement");
      },
      4664: function _(t, e, n) {
        var r = n(9781),
            d = n(7293),
            i = n(317);
        t.exports = !r && !d(function () {
          return 7 != Object.defineProperty(i("div"), "a", {
            get: function get() {
              return 7;
            }
          }).a;
        });
      },
      8361: function _(t, e, n) {
        var r = n(7293),
            d = n(4326),
            i = "".split;
        t.exports = r(function () {
          return !Object("z").propertyIsEnumerable(0);
        }) ? function (t) {
          return "String" == d(t) ? i.call(t, "") : Object(t);
        } : Object;
      },
      9587: function _(t, e, n) {
        var r = n(111),
            d = n(7674);

        t.exports = function (t, e, n) {
          var i, o;
          return d && "function" == typeof (i = e.constructor) && i !== n && r(o = i.prototype) && o !== n.prototype && d(t, o), t;
        };
      },
      2788: function _(t, e, n) {
        var r = n(5465),
            d = Function.toString;
        "function" != typeof r.inspectSource && (r.inspectSource = function (t) {
          return d.call(t);
        }), t.exports = r.inspectSource;
      },
      9909: function _(t, e, n) {
        var r,
            d,
            i,
            o = n(8536),
            a = n(7854),
            u = n(111),
            $ = n(8880),
            c = n(6656),
            s = n(5465),
            l = n(6200),
            f = n(3501),
            p = "Object already initialized",
            h = a.WeakMap,
            v = function v(t) {
          return i(t) ? d(t) : r(t, {});
        },
            y = function y(t) {
          return function (e) {
            var n;
            if (!u(e) || (n = d(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
            return n;
          };
        };

        if (o || s.state) {
          var g = s.state || (s.state = new h()),
              m = g.get,
              b = g.has,
              C = g.set;
          r = function r(t, e) {
            if (b.call(g, t)) throw new TypeError(p);
            return e.facade = t, C.call(g, t, e), e;
          }, d = function d(t) {
            return m.call(g, t) || {};
          }, i = function i(t) {
            return b.call(g, t);
          };
        } else {
          var x = l("state");
          f[x] = !0, r = function r(t, e) {
            if (c(t, x)) throw new TypeError(p);
            return e.facade = t, $(t, x, e), e;
          }, d = function d(t) {
            return c(t, x) ? t[x] : {};
          }, i = function i(t) {
            return c(t, x);
          };
        }

        t.exports = {
          set: r,
          get: d,
          has: i,
          enforce: v,
          getterFor: y
        };
      },
      7659: function _(t, e, n) {
        var r = n(5112),
            d = n(7497),
            i = r("iterator"),
            o = Array.prototype;

        t.exports = function (t) {
          return void 0 !== t && (d.Array === t || o[i] === t);
        };
      },
      3157: function _(t, e, n) {
        var r = n(4326);

        t.exports = Array.isArray || function (t) {
          return "Array" == r(t);
        };
      },
      4705: function _(t, e, n) {
        var r = n(7293),
            d = /#|\.prototype\./,
            i = function i(t, e) {
          var n = a[o(t)];
          return n == $ || n != u && ("function" == typeof e ? r(e) : !!e);
        },
            o = i.normalize = function (t) {
          return String(t).replace(d, ".").toLowerCase();
        },
            a = i.data = {},
            u = i.NATIVE = "N",
            $ = i.POLYFILL = "P";

        t.exports = i;
      },
      111: function _(t) {
        t.exports = function (t) {
          return "object" === _typeof(t) ? null !== t : "function" === typeof t;
        };
      },
      1913: function _(t) {
        t.exports = !1;
      },
      7850: function _(t, e, n) {
        var r = n(111),
            d = n(4326),
            i = n(5112),
            o = i("match");

        t.exports = function (t) {
          var e;
          return r(t) && (void 0 !== (e = t[o]) ? !!e : "RegExp" == d(t));
        };
      },
      408: function _(t, e, n) {
        var r = n(9670),
            d = n(7659),
            i = n(7466),
            o = n(9974),
            a = n(1246),
            u = n(9212),
            $ = function $(t, e) {
          this.stopped = t, this.result = e;
        };

        t.exports = function (t, e, n) {
          var c,
              s,
              l,
              f,
              p,
              h,
              v,
              y = n && n.that,
              g = !(!n || !n.AS_ENTRIES),
              m = !(!n || !n.IS_ITERATOR),
              b = !(!n || !n.INTERRUPTED),
              C = o(e, y, 1 + g + b),
              x = function x(t) {
            return c && u(c), new $(!0, t);
          },
              O = function O(t) {
            return g ? (r(t), b ? C(t[0], t[1], x) : C(t[0], t[1])) : b ? C(t, x) : C(t);
          };

          if (m) c = t;else {
            if (s = a(t), "function" != typeof s) throw TypeError("Target is not iterable");

            if (d(s)) {
              for (l = 0, f = i(t.length); f > l; l++) {
                if (p = O(t[l]), p && p instanceof $) return p;
              }

              return new $(!1);
            }

            c = s.call(t);
          }
          h = c.next;

          while (!(v = h.call(c)).done) {
            try {
              p = O(v.value);
            } catch (w) {
              throw u(c), w;
            }

            if ("object" == _typeof(p) && p && p instanceof $) return p;
          }

          return new $(!1);
        };
      },
      9212: function _(t, e, n) {
        var r = n(9670);

        t.exports = function (t) {
          var e = t["return"];
          if (void 0 !== e) return r(e.call(t)).value;
        };
      },
      3383: function _(t, e, n) {
        "use strict";

        var r,
            d,
            i,
            o = n(7293),
            a = n(9518),
            u = n(8880),
            $ = n(6656),
            c = n(5112),
            s = n(1913),
            l = c("iterator"),
            f = !1,
            p = function p() {
          return this;
        };

        [].keys && (i = [].keys(), "next" in i ? (d = a(a(i)), d !== Object.prototype && (r = d)) : f = !0);
        var h = void 0 == r || o(function () {
          var t = {};
          return r[l].call(t) !== t;
        });
        h && (r = {}), s && !h || $(r, l) || u(r, l, p), t.exports = {
          IteratorPrototype: r,
          BUGGY_SAFARI_ITERATORS: f
        };
      },
      7497: function _(t) {
        t.exports = {};
      },
      5948: function _(t, e, n) {
        var r,
            d,
            i,
            o,
            a,
            u,
            $,
            c,
            s = n(7854),
            l = n(1236).f,
            f = n(261).set,
            p = n(6833),
            h = n(1036),
            v = n(5268),
            y = s.MutationObserver || s.WebKitMutationObserver,
            g = s.document,
            m = s.process,
            b = s.Promise,
            C = l(s, "queueMicrotask"),
            x = C && C.value;
        x || (r = function r() {
          var t, e;
          v && (t = m.domain) && t.exit();

          while (d) {
            e = d.fn, d = d.next;

            try {
              e();
            } catch (n) {
              throw d ? o() : i = void 0, n;
            }
          }

          i = void 0, t && t.enter();
        }, p || v || h || !y || !g ? b && b.resolve ? ($ = b.resolve(void 0), $.constructor = b, c = $.then, o = function o() {
          c.call($, r);
        }) : o = v ? function () {
          m.nextTick(r);
        } : function () {
          f.call(s, r);
        } : (a = !0, u = g.createTextNode(""), new y(r).observe(u, {
          characterData: !0
        }), o = function o() {
          u.data = a = !a;
        })), t.exports = x || function (t) {
          var e = {
            fn: t,
            next: void 0
          };
          i && (i.next = e), d || (d = e, o()), i = e;
        };
      },
      3366: function _(t, e, n) {
        var r = n(7854);
        t.exports = r.Promise;
      },
      133: function _(t, e, n) {
        var r = n(7392),
            d = n(7293);
        t.exports = !!Object.getOwnPropertySymbols && !d(function () {
          var t = Symbol();
          return !String(t) || !(Object(t) instanceof Symbol) || !Symbol.sham && r && r < 41;
        });
      },
      8536: function _(t, e, n) {
        var r = n(7854),
            d = n(2788),
            i = r.WeakMap;
        t.exports = "function" === typeof i && /native code/.test(d(i));
      },
      8523: function _(t, e, n) {
        "use strict";

        var r = n(3099),
            d = function d(t) {
          var e, n;
          this.promise = new t(function (t, r) {
            if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
            e = t, n = r;
          }), this.resolve = r(e), this.reject = r(n);
        };

        t.exports.f = function (t) {
          return new d(t);
        };
      },
      3929: function _(t, e, n) {
        var r = n(7850);

        t.exports = function (t) {
          if (r(t)) throw TypeError("The method doesn't accept regular expressions");
          return t;
        };
      },
      1574: function _(t, e, n) {
        "use strict";

        var r = n(9781),
            d = n(7293),
            i = n(1956),
            o = n(5181),
            a = n(5296),
            u = n(7908),
            $ = n(8361),
            c = Object.assign,
            s = Object.defineProperty;
        t.exports = !c || d(function () {
          if (r && 1 !== c({
            b: 1
          }, c(s({}, "a", {
            enumerable: !0,
            get: function get() {
              s(this, "b", {
                value: 3,
                enumerable: !1
              });
            }
          }), {
            b: 2
          })).b) return !0;
          var t = {},
              e = {},
              n = Symbol(),
              d = "abcdefghijklmnopqrst";
          return t[n] = 7, d.split("").forEach(function (t) {
            e[t] = t;
          }), 7 != c({}, t)[n] || i(c({}, e)).join("") != d;
        }) ? function (t, e) {
          var n = u(t),
              d = arguments.length,
              c = 1,
              s = o.f,
              l = a.f;

          while (d > c) {
            var f,
                p = $(arguments[c++]),
                h = s ? i(p).concat(s(p)) : i(p),
                v = h.length,
                y = 0;

            while (v > y) {
              f = h[y++], r && !l.call(p, f) || (n[f] = p[f]);
            }
          }

          return n;
        } : c;
      },
      30: function _(t, e, n) {
        var r,
            d = n(9670),
            i = n(6048),
            o = n(748),
            a = n(3501),
            u = n(490),
            $ = n(317),
            c = n(6200),
            s = ">",
            l = "<",
            f = "prototype",
            p = "script",
            h = c("IE_PROTO"),
            v = function v() {},
            y = function y(t) {
          return l + p + s + t + l + "/" + p + s;
        },
            g = function g(t) {
          t.write(y("")), t.close();
          var e = t.parentWindow.Object;
          return t = null, e;
        },
            m = function m() {
          var t,
              e = $("iframe"),
              n = "java" + p + ":";
          return e.style.display = "none", u.appendChild(e), e.src = String(n), t = e.contentWindow.document, t.open(), t.write(y("document.F=Object")), t.close(), t.F;
        },
            _b = function b() {
          try {
            r = document.domain && new ActiveXObject("htmlfile");
          } catch (e) {}

          _b = r ? g(r) : m();
          var t = o.length;

          while (t--) {
            delete _b[f][o[t]];
          }

          return _b();
        };

        a[h] = !0, t.exports = Object.create || function (t, e) {
          var n;
          return null !== t ? (v[f] = d(t), n = new v(), v[f] = null, n[h] = t) : n = _b(), void 0 === e ? n : i(n, e);
        };
      },
      6048: function _(t, e, n) {
        var r = n(9781),
            d = n(3070),
            i = n(9670),
            o = n(1956);
        t.exports = r ? Object.defineProperties : function (t, e) {
          i(t);
          var n,
              r = o(e),
              a = r.length,
              u = 0;

          while (a > u) {
            d.f(t, n = r[u++], e[n]);
          }

          return t;
        };
      },
      3070: function _(t, e, n) {
        var r = n(9781),
            d = n(4664),
            i = n(9670),
            o = n(7593),
            a = Object.defineProperty;
        e.f = r ? a : function (t, e, n) {
          if (i(t), e = o(e, !0), i(n), d) try {
            return a(t, e, n);
          } catch (r) {}
          if ("get" in n || "set" in n) throw TypeError("Accessors not supported");
          return "value" in n && (t[e] = n.value), t;
        };
      },
      1236: function _(t, e, n) {
        var r = n(9781),
            d = n(5296),
            i = n(9114),
            o = n(5656),
            a = n(7593),
            u = n(6656),
            $ = n(4664),
            c = Object.getOwnPropertyDescriptor;
        e.f = r ? c : function (t, e) {
          if (t = o(t), e = a(e, !0), $) try {
            return c(t, e);
          } catch (n) {}
          if (u(t, e)) return i(!d.f.call(t, e), t[e]);
        };
      },
      1156: function _(t, e, n) {
        var r = n(5656),
            d = n(8006).f,
            i = {}.toString,
            o = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
            a = function a(t) {
          try {
            return d(t);
          } catch (e) {
            return o.slice();
          }
        };

        t.exports.f = function (t) {
          return o && "[object Window]" == i.call(t) ? a(t) : d(r(t));
        };
      },
      8006: function _(t, e, n) {
        var r = n(6324),
            d = n(748),
            i = d.concat("length", "prototype");

        e.f = Object.getOwnPropertyNames || function (t) {
          return r(t, i);
        };
      },
      5181: function _(t, e) {
        e.f = Object.getOwnPropertySymbols;
      },
      9518: function _(t, e, n) {
        var r = n(6656),
            d = n(7908),
            i = n(6200),
            o = n(8544),
            a = i("IE_PROTO"),
            u = Object.prototype;
        t.exports = o ? Object.getPrototypeOf : function (t) {
          return t = d(t), r(t, a) ? t[a] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
        };
      },
      6324: function _(t, e, n) {
        var r = n(6656),
            d = n(5656),
            i = n(1318).indexOf,
            o = n(3501);

        t.exports = function (t, e) {
          var n,
              a = d(t),
              u = 0,
              $ = [];

          for (n in a) {
            !r(o, n) && r(a, n) && $.push(n);
          }

          while (e.length > u) {
            r(a, n = e[u++]) && (~i($, n) || $.push(n));
          }

          return $;
        };
      },
      1956: function _(t, e, n) {
        var r = n(6324),
            d = n(748);

        t.exports = Object.keys || function (t) {
          return r(t, d);
        };
      },
      5296: function _(t, e) {
        "use strict";

        var n = {}.propertyIsEnumerable,
            r = Object.getOwnPropertyDescriptor,
            d = r && !n.call({
          1: 2
        }, 1);
        e.f = d ? function (t) {
          var e = r(this, t);
          return !!e && e.enumerable;
        } : n;
      },
      7674: function _(t, e, n) {
        var r = n(9670),
            d = n(6077);
        t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
          var t,
              e = !1,
              n = {};

          try {
            t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, t.call(n, []), e = n instanceof Array;
          } catch (i) {}

          return function (n, i) {
            return r(n), d(i), e ? t.call(n, i) : n.__proto__ = i, n;
          };
        }() : void 0);
      },
      288: function _(t, e, n) {
        "use strict";

        var r = n(1694),
            d = n(648);
        t.exports = r ? {}.toString : function () {
          return "[object " + d(this) + "]";
        };
      },
      3887: function _(t, e, n) {
        var r = n(5005),
            d = n(8006),
            i = n(5181),
            o = n(9670);

        t.exports = r("Reflect", "ownKeys") || function (t) {
          var e = d.f(o(t)),
              n = i.f;
          return n ? e.concat(n(t)) : e;
        };
      },
      857: function _(t, e, n) {
        var r = n(7854);
        t.exports = r;
      },
      2534: function _(t) {
        t.exports = function (t) {
          try {
            return {
              error: !1,
              value: t()
            };
          } catch (e) {
            return {
              error: !0,
              value: e
            };
          }
        };
      },
      9478: function _(t, e, n) {
        var r = n(9670),
            d = n(111),
            i = n(8523);

        t.exports = function (t, e) {
          if (r(t), d(e) && e.constructor === t) return e;
          var n = i.f(t),
              o = n.resolve;
          return o(e), n.promise;
        };
      },
      2248: function _(t, e, n) {
        var r = n(1320);

        t.exports = function (t, e, n) {
          for (var d in e) {
            r(t, d, e[d], n);
          }

          return t;
        };
      },
      1320: function _(t, e, n) {
        var r = n(7854),
            d = n(8880),
            i = n(6656),
            o = n(3505),
            a = n(2788),
            u = n(9909),
            $ = u.get,
            c = u.enforce,
            s = String(String).split("String");
        (t.exports = function (t, e, n, a) {
          var u,
              $ = !!a && !!a.unsafe,
              l = !!a && !!a.enumerable,
              f = !!a && !!a.noTargetGet;
          "function" == typeof n && ("string" != typeof e || i(n, "name") || d(n, "name", e), u = c(n), u.source || (u.source = s.join("string" == typeof e ? e : ""))), t !== r ? ($ ? !f && t[e] && (l = !0) : delete t[e], l ? t[e] = n : d(t, e, n)) : l ? t[e] = n : o(e, n);
        })(Function.prototype, "toString", function () {
          return "function" == typeof this && $(this).source || a(this);
        });
      },
      7651: function _(t, e, n) {
        var r = n(4326),
            d = n(2261);

        t.exports = function (t, e) {
          var n = t.exec;

          if ("function" === typeof n) {
            var i = n.call(t, e);
            if ("object" !== _typeof(i)) throw TypeError("RegExp exec method returned something other than an Object or null");
            return i;
          }

          if ("RegExp" !== r(t)) throw TypeError("RegExp#exec called on incompatible receiver");
          return d.call(t, e);
        };
      },
      2261: function _(t, e, n) {
        "use strict";

        var r = n(7066),
            d = n(2999),
            i = n(2309),
            o = RegExp.prototype.exec,
            a = i("native-string-replace", String.prototype.replace),
            u = o,
            $ = function () {
          var t = /a/,
              e = /b*/g;
          return o.call(t, "a"), o.call(e, "a"), 0 !== t.lastIndex || 0 !== e.lastIndex;
        }(),
            c = d.UNSUPPORTED_Y || d.BROKEN_CARET,
            s = void 0 !== /()??/.exec("")[1],
            l = $ || s || c;

        l && (u = function u(t) {
          var e,
              n,
              d,
              i,
              u = this,
              l = c && u.sticky,
              f = r.call(u),
              p = u.source,
              h = 0,
              v = t;
          return l && (f = f.replace("y", ""), -1 === f.indexOf("g") && (f += "g"), v = String(t).slice(u.lastIndex), u.lastIndex > 0 && (!u.multiline || u.multiline && "\n" !== t[u.lastIndex - 1]) && (p = "(?: " + p + ")", v = " " + v, h++), n = new RegExp("^(?:" + p + ")", f)), s && (n = new RegExp("^" + p + "$(?!\\s)", f)), $ && (e = u.lastIndex), d = o.call(l ? n : u, v), l ? d ? (d.input = d.input.slice(h), d[0] = d[0].slice(h), d.index = u.lastIndex, u.lastIndex += d[0].length) : u.lastIndex = 0 : $ && d && (u.lastIndex = u.global ? d.index + d[0].length : e), s && d && d.length > 1 && a.call(d[0], n, function () {
            for (i = 1; i < arguments.length - 2; i++) {
              void 0 === arguments[i] && (d[i] = void 0);
            }
          }), d;
        }), t.exports = u;
      },
      7066: function _(t, e, n) {
        "use strict";

        var r = n(9670);

        t.exports = function () {
          var t = r(this),
              e = "";
          return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
        };
      },
      2999: function _(t, e, n) {
        "use strict";

        var r = n(7293);

        function d(t, e) {
          return RegExp(t, e);
        }

        e.UNSUPPORTED_Y = r(function () {
          var t = d("a", "y");
          return t.lastIndex = 2, null != t.exec("abcd");
        }), e.BROKEN_CARET = r(function () {
          var t = d("^r", "gy");
          return t.lastIndex = 2, null != t.exec("str");
        });
      },
      4488: function _(t) {
        t.exports = function (t) {
          if (void 0 == t) throw TypeError("Can't call method on " + t);
          return t;
        };
      },
      3505: function _(t, e, n) {
        var r = n(7854),
            d = n(8880);

        t.exports = function (t, e) {
          try {
            d(r, t, e);
          } catch (n) {
            r[t] = e;
          }

          return e;
        };
      },
      6340: function _(t, e, n) {
        "use strict";

        var r = n(5005),
            d = n(3070),
            i = n(5112),
            o = n(9781),
            a = i("species");

        t.exports = function (t) {
          var e = r(t),
              n = d.f;
          o && e && !e[a] && n(e, a, {
            configurable: !0,
            get: function get() {
              return this;
            }
          });
        };
      },
      8003: function _(t, e, n) {
        var r = n(3070).f,
            d = n(6656),
            i = n(5112),
            o = i("toStringTag");

        t.exports = function (t, e, n) {
          t && !d(t = n ? t : t.prototype, o) && r(t, o, {
            configurable: !0,
            value: e
          });
        };
      },
      6200: function _(t, e, n) {
        var r = n(2309),
            d = n(9711),
            i = r("keys");

        t.exports = function (t) {
          return i[t] || (i[t] = d(t));
        };
      },
      5465: function _(t, e, n) {
        var r = n(7854),
            d = n(3505),
            i = "__core-js_shared__",
            o = r[i] || d(i, {});
        t.exports = o;
      },
      2309: function _(t, e, n) {
        var r = n(1913),
            d = n(5465);
        (t.exports = function (t, e) {
          return d[t] || (d[t] = void 0 !== e ? e : {});
        })("versions", []).push({
          version: "3.14.0",
          mode: r ? "pure" : "global",
          copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
        });
      },
      6707: function _(t, e, n) {
        var r = n(9670),
            d = n(3099),
            i = n(5112),
            o = i("species");

        t.exports = function (t, e) {
          var n,
              i = r(t).constructor;
          return void 0 === i || void 0 == (n = r(i)[o]) ? e : d(n);
        };
      },
      8710: function _(t, e, n) {
        var r = n(9958),
            d = n(4488),
            i = function i(t) {
          return function (e, n) {
            var i,
                o,
                a = String(d(e)),
                u = r(n),
                $ = a.length;
            return u < 0 || u >= $ ? t ? "" : void 0 : (i = a.charCodeAt(u), i < 55296 || i > 56319 || u + 1 === $ || (o = a.charCodeAt(u + 1)) < 56320 || o > 57343 ? t ? a.charAt(u) : i : t ? a.slice(u, u + 2) : o - 56320 + (i - 55296 << 10) + 65536);
          };
        };

        t.exports = {
          codeAt: i(!1),
          charAt: i(!0)
        };
      },
      6091: function _(t, e, n) {
        var r = n(7293),
            d = n(1361),
            i = "​᠎";

        t.exports = function (t) {
          return r(function () {
            return !!d[t]() || i[t]() != i || d[t].name !== t;
          });
        };
      },
      3111: function _(t, e, n) {
        var r = n(4488),
            d = n(1361),
            i = "[" + d + "]",
            o = RegExp("^" + i + i + "*"),
            a = RegExp(i + i + "*$"),
            u = function u(t) {
          return function (e) {
            var n = String(r(e));
            return 1 & t && (n = n.replace(o, "")), 2 & t && (n = n.replace(a, "")), n;
          };
        };

        t.exports = {
          start: u(1),
          end: u(2),
          trim: u(3)
        };
      },
      261: function _(t, e, n) {
        var r,
            d,
            i,
            o = n(7854),
            a = n(7293),
            u = n(9974),
            $ = n(490),
            c = n(317),
            s = n(6833),
            l = n(5268),
            f = o.location,
            p = o.setImmediate,
            h = o.clearImmediate,
            v = o.process,
            y = o.MessageChannel,
            g = o.Dispatch,
            m = 0,
            b = {},
            C = "onreadystatechange",
            x = function x(t) {
          if (b.hasOwnProperty(t)) {
            var e = b[t];
            delete b[t], e();
          }
        },
            O = function O(t) {
          return function () {
            x(t);
          };
        },
            w = function w(t) {
          x(t.data);
        },
            S = function S(t) {
          o.postMessage(t + "", f.protocol + "//" + f.host);
        };

        p && h || (p = function p(t) {
          var e = [],
              n = 1;

          while (arguments.length > n) {
            e.push(arguments[n++]);
          }

          return b[++m] = function () {
            ("function" == typeof t ? t : Function(t)).apply(void 0, e);
          }, r(m), m;
        }, h = function h(t) {
          delete b[t];
        }, l ? r = function r(t) {
          v.nextTick(O(t));
        } : g && g.now ? r = function r(t) {
          g.now(O(t));
        } : y && !s ? (d = new y(), i = d.port2, d.port1.onmessage = w, r = u(i.postMessage, i, 1)) : o.addEventListener && "function" == typeof postMessage && !o.importScripts && f && "file:" !== f.protocol && !a(S) ? (r = S, o.addEventListener("message", w, !1)) : r = C in c("script") ? function (t) {
          $.appendChild(c("script"))[C] = function () {
            $.removeChild(this), x(t);
          };
        } : function (t) {
          setTimeout(O(t), 0);
        }), t.exports = {
          set: p,
          clear: h
        };
      },
      1400: function _(t, e, n) {
        var r = n(9958),
            d = Math.max,
            i = Math.min;

        t.exports = function (t, e) {
          var n = r(t);
          return n < 0 ? d(n + e, 0) : i(n, e);
        };
      },
      5656: function _(t, e, n) {
        var r = n(8361),
            d = n(4488);

        t.exports = function (t) {
          return r(d(t));
        };
      },
      9958: function _(t) {
        var e = Math.ceil,
            n = Math.floor;

        t.exports = function (t) {
          return isNaN(t = +t) ? 0 : (t > 0 ? n : e)(t);
        };
      },
      7466: function _(t, e, n) {
        var r = n(9958),
            d = Math.min;

        t.exports = function (t) {
          return t > 0 ? d(r(t), 9007199254740991) : 0;
        };
      },
      7908: function _(t, e, n) {
        var r = n(4488);

        t.exports = function (t) {
          return Object(r(t));
        };
      },
      7593: function _(t, e, n) {
        var r = n(111);

        t.exports = function (t, e) {
          if (!r(t)) return t;
          var n, d;
          if (e && "function" == typeof (n = t.toString) && !r(d = n.call(t))) return d;
          if ("function" == typeof (n = t.valueOf) && !r(d = n.call(t))) return d;
          if (!e && "function" == typeof (n = t.toString) && !r(d = n.call(t))) return d;
          throw TypeError("Can't convert object to primitive value");
        };
      },
      1694: function _(t, e, n) {
        var r = n(5112),
            d = r("toStringTag"),
            i = {};
        i[d] = "z", t.exports = "[object z]" === String(i);
      },
      9711: function _(t) {
        var e = 0,
            n = Math.random();

        t.exports = function (t) {
          return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++e + n).toString(36);
        };
      },
      3307: function _(t, e, n) {
        var r = n(133);
        t.exports = r && !Symbol.sham && "symbol" == _typeof(Symbol.iterator);
      },
      6061: function _(t, e, n) {
        var r = n(5112);
        e.f = r;
      },
      5112: function _(t, e, n) {
        var r = n(7854),
            d = n(2309),
            i = n(6656),
            o = n(9711),
            a = n(133),
            u = n(3307),
            $ = d("wks"),
            c = r.Symbol,
            s = u ? c : c && c.withoutSetter || o;

        t.exports = function (t) {
          return i($, t) && (a || "string" == typeof $[t]) || (a && i(c, t) ? $[t] = c[t] : $[t] = s("Symbol." + t)), $[t];
        };
      },
      1361: function _(t) {
        t.exports = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
      },
      2222: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(7293),
            i = n(3157),
            o = n(111),
            a = n(7908),
            u = n(7466),
            $ = n(6135),
            c = n(5417),
            s = n(1194),
            l = n(5112),
            f = n(7392),
            p = l("isConcatSpreadable"),
            h = 9007199254740991,
            v = "Maximum allowed index exceeded",
            y = f >= 51 || !d(function () {
          var t = [];
          return t[p] = !1, t.concat()[0] !== t;
        }),
            g = s("concat"),
            m = function m(t) {
          if (!o(t)) return !1;
          var e = t[p];
          return void 0 !== e ? !!e : i(t);
        },
            b = !y || !g;

        r({
          target: "Array",
          proto: !0,
          forced: b
        }, {
          concat: function concat(t) {
            var e,
                n,
                r,
                d,
                i,
                o = a(this),
                s = c(o, 0),
                l = 0;

            for (e = -1, r = arguments.length; e < r; e++) {
              if (i = -1 === e ? o : arguments[e], m(i)) {
                if (d = u(i.length), l + d > h) throw TypeError(v);

                for (n = 0; n < d; n++, l++) {
                  n in i && $(s, l, i[n]);
                }
              } else {
                if (l >= h) throw TypeError(v);
                $(s, l++, i);
              }
            }

            return s.length = l, s;
          }
        });
      },
      7327: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(2092).filter,
            i = n(1194),
            o = i("filter");
        r({
          target: "Array",
          proto: !0,
          forced: !o
        }, {
          filter: function filter(t) {
            return d(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      },
      4553: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(2092).findIndex,
            i = n(1223),
            o = "findIndex",
            a = !0;
        o in [] && Array(1)[o](function () {
          a = !1;
        }), r({
          target: "Array",
          proto: !0,
          forced: a
        }, {
          findIndex: function findIndex(t) {
            return d(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        }), i(o);
      },
      9826: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(2092).find,
            i = n(1223),
            o = "find",
            a = !0;
        o in [] && Array(1)[o](function () {
          a = !1;
        }), r({
          target: "Array",
          proto: !0,
          forced: a
        }, {
          find: function find(t) {
            return d(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        }), i(o);
      },
      1038: function _(t, e, n) {
        var r = n(2109),
            d = n(8457),
            i = n(7072),
            o = !i(function (t) {
          Array.from(t);
        });
        r({
          target: "Array",
          stat: !0,
          forced: o
        }, {
          from: d
        });
      },
      6699: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(1318).includes,
            i = n(1223);
        r({
          target: "Array",
          proto: !0
        }, {
          includes: function includes(t) {
            return d(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        }), i("includes");
      },
      6992: function _(t, e, n) {
        "use strict";

        var r = n(5656),
            d = n(1223),
            i = n(7497),
            o = n(9909),
            a = n(654),
            u = "Array Iterator",
            $ = o.set,
            c = o.getterFor(u);
        t.exports = a(Array, "Array", function (t, e) {
          $(this, {
            type: u,
            target: r(t),
            index: 0,
            kind: e
          });
        }, function () {
          var t = c(this),
              e = t.target,
              n = t.kind,
              r = t.index++;
          return !e || r >= e.length ? (t.target = void 0, {
            value: void 0,
            done: !0
          }) : "keys" == n ? {
            value: r,
            done: !1
          } : "values" == n ? {
            value: e[r],
            done: !1
          } : {
            value: [r, e[r]],
            done: !1
          };
        }, "values"), i.Arguments = i.Array, d("keys"), d("values"), d("entries");
      },
      9600: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(8361),
            i = n(5656),
            o = n(9341),
            a = [].join,
            u = d != Object,
            $ = o("join", ",");
        r({
          target: "Array",
          proto: !0,
          forced: u || !$
        }, {
          join: function join(t) {
            return a.call(i(this), void 0 === t ? "," : t);
          }
        });
      },
      1249: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(2092).map,
            i = n(1194),
            o = i("map");
        r({
          target: "Array",
          proto: !0,
          forced: !o
        }, {
          map: function map(t) {
            return d(this, t, arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      },
      7042: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(111),
            i = n(3157),
            o = n(1400),
            a = n(7466),
            u = n(5656),
            $ = n(6135),
            c = n(5112),
            s = n(1194),
            l = s("slice"),
            f = c("species"),
            p = [].slice,
            h = Math.max;
        r({
          target: "Array",
          proto: !0,
          forced: !l
        }, {
          slice: function slice(t, e) {
            var n,
                r,
                c,
                s = u(this),
                l = a(s.length),
                v = o(t, l),
                y = o(void 0 === e ? l : e, l);
            if (i(s) && (n = s.constructor, "function" != typeof n || n !== Array && !i(n.prototype) ? d(n) && (n = n[f], null === n && (n = void 0)) : n = void 0, n === Array || void 0 === n)) return p.call(s, v, y);

            for (r = new (void 0 === n ? Array : n)(h(y - v, 0)), c = 0; v < y; v++, c++) {
              v in s && $(r, c, s[v]);
            }

            return r.length = c, r;
          }
        });
      },
      8309: function _(t, e, n) {
        var r = n(9781),
            d = n(3070).f,
            i = Function.prototype,
            o = i.toString,
            a = /^\s*function ([^ (]*)/,
            u = "name";
        r && !(u in i) && d(i, u, {
          configurable: !0,
          get: function get() {
            try {
              return o.call(this).match(a)[1];
            } catch (t) {
              return "";
            }
          }
        });
      },
      9653: function _(t, e, n) {
        "use strict";

        var r = n(9781),
            d = n(7854),
            i = n(4705),
            o = n(1320),
            a = n(6656),
            u = n(4326),
            $ = n(9587),
            c = n(7593),
            s = n(7293),
            l = n(30),
            f = n(8006).f,
            p = n(1236).f,
            h = n(3070).f,
            v = n(3111).trim,
            y = "Number",
            g = d[y],
            m = g.prototype,
            b = u(l(m)) == y,
            C = function C(t) {
          var e,
              n,
              r,
              d,
              i,
              o,
              a,
              u,
              $ = c(t, !1);
          if ("string" == typeof $ && $.length > 2) if ($ = v($), e = $.charCodeAt(0), 43 === e || 45 === e) {
            if (n = $.charCodeAt(2), 88 === n || 120 === n) return NaN;
          } else if (48 === e) {
            switch ($.charCodeAt(1)) {
              case 66:
              case 98:
                r = 2, d = 49;
                break;

              case 79:
              case 111:
                r = 8, d = 55;
                break;

              default:
                return +$;
            }

            for (i = $.slice(2), o = i.length, a = 0; a < o; a++) {
              if (u = i.charCodeAt(a), u < 48 || u > d) return NaN;
            }

            return parseInt(i, r);
          }
          return +$;
        };

        if (i(y, !g(" 0o1") || !g("0b1") || g("+0x1"))) {
          for (var x, O = function O(t) {
            var e = arguments.length < 1 ? 0 : t,
                n = this;
            return n instanceof O && (b ? s(function () {
              m.valueOf.call(n);
            }) : u(n) != y) ? $(new g(C(e)), n, O) : C(e);
          }, w = r ? f(g) : "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,fromString,range".split(","), S = 0; w.length > S; S++) {
            a(g, x = w[S]) && !a(O, x) && h(O, x, p(g, x));
          }

          O.prototype = m, m.constructor = O, o(d, y, O);
        }
      },
      9601: function _(t, e, n) {
        var r = n(2109),
            d = n(1574);
        r({
          target: "Object",
          stat: !0,
          forced: Object.assign !== d
        }, {
          assign: d
        });
      },
      5003: function _(t, e, n) {
        var r = n(2109),
            d = n(7293),
            i = n(5656),
            o = n(1236).f,
            a = n(9781),
            u = d(function () {
          o(1);
        }),
            $ = !a || u;
        r({
          target: "Object",
          stat: !0,
          forced: $,
          sham: !a
        }, {
          getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
            return o(i(t), e);
          }
        });
      },
      9337: function _(t, e, n) {
        var r = n(2109),
            d = n(9781),
            i = n(3887),
            o = n(5656),
            a = n(1236),
            u = n(6135);
        r({
          target: "Object",
          stat: !0,
          sham: !d
        }, {
          getOwnPropertyDescriptors: function getOwnPropertyDescriptors(t) {
            var e,
                n,
                r = o(t),
                d = a.f,
                $ = i(r),
                c = {},
                s = 0;

            while ($.length > s) {
              n = d(r, e = $[s++]), void 0 !== n && u(c, e, n);
            }

            return c;
          }
        });
      },
      7941: function _(t, e, n) {
        var r = n(2109),
            d = n(7908),
            i = n(1956),
            o = n(7293),
            a = o(function () {
          i(1);
        });
        r({
          target: "Object",
          stat: !0,
          forced: a
        }, {
          keys: function keys(t) {
            return i(d(t));
          }
        });
      },
      1539: function _(t, e, n) {
        var r = n(1694),
            d = n(1320),
            i = n(288);
        r || d(Object.prototype, "toString", i, {
          unsafe: !0
        });
      },
      8674: function _(t, e, n) {
        "use strict";

        var r,
            d,
            i,
            o,
            a = n(2109),
            u = n(1913),
            $ = n(7854),
            c = n(5005),
            s = n(3366),
            l = n(1320),
            f = n(2248),
            p = n(7674),
            h = n(8003),
            v = n(6340),
            y = n(111),
            g = n(3099),
            m = n(5787),
            b = n(2788),
            C = n(408),
            x = n(7072),
            O = n(6707),
            w = n(261).set,
            S = n(5948),
            E = n(9478),
            P = n(842),
            I = n(8523),
            N = n(2534),
            k = n(9909),
            T = n(4705),
            A = n(5112),
            j = n(7871),
            _ = n(5268),
            M = n(7392),
            R = A("species"),
            D = "Promise",
            L = k.get,
            F = k.set,
            B = k.getterFor(D),
            G = s && s.prototype,
            _U = s,
            V = G,
            K = $.TypeError,
            H = $.document,
            W = $.process,
            z = I.f,
            Y = z,
            Z = !!(H && H.createEvent && $.dispatchEvent),
            q = "function" == typeof PromiseRejectionEvent,
            J = "unhandledrejection",
            X = "rejectionhandled",
            Q = 0,
            tt = 1,
            et = 2,
            nt = 1,
            rt = 2,
            dt = !1,
            it = T(D, function () {
          var t = b(_U) !== String(_U);
          if (!t && 66 === M) return !0;
          if (u && !V["finally"]) return !0;
          if (M >= 51 && /native code/.test(_U)) return !1;

          var e = new _U(function (t) {
            t(1);
          }),
              n = function n(t) {
            t(function () {}, function () {});
          },
              r = e.constructor = {};

          return r[R] = n, dt = e.then(function () {}) instanceof n, !dt || !t && j && !q;
        }),
            ot = it || !x(function (t) {
          _U.all(t)["catch"](function () {});
        }),
            at = function at(t) {
          var e;
          return !(!y(t) || "function" != typeof (e = t.then)) && e;
        },
            ut = function ut(t, e) {
          if (!t.notified) {
            t.notified = !0;
            var n = t.reactions;
            S(function () {
              var r = t.value,
                  d = t.state == tt,
                  i = 0;

              while (n.length > i) {
                var o,
                    a,
                    u,
                    $ = n[i++],
                    c = d ? $.ok : $.fail,
                    s = $.resolve,
                    l = $.reject,
                    f = $.domain;

                try {
                  c ? (d || (t.rejection === rt && lt(t), t.rejection = nt), !0 === c ? o = r : (f && f.enter(), o = c(r), f && (f.exit(), u = !0)), o === $.promise ? l(K("Promise-chain cycle")) : (a = at(o)) ? a.call(o, s, l) : s(o)) : l(r);
                } catch (p) {
                  f && !u && f.exit(), l(p);
                }
              }

              t.reactions = [], t.notified = !1, e && !t.rejection && ct(t);
            });
          }
        },
            $t = function $t(t, e, n) {
          var r, d;
          Z ? (r = H.createEvent("Event"), r.promise = e, r.reason = n, r.initEvent(t, !1, !0), $.dispatchEvent(r)) : r = {
            promise: e,
            reason: n
          }, !q && (d = $["on" + t]) ? d(r) : t === J && P("Unhandled promise rejection", n);
        },
            ct = function ct(t) {
          w.call($, function () {
            var e,
                n = t.facade,
                r = t.value,
                d = st(t);
            if (d && (e = N(function () {
              _ ? W.emit("unhandledRejection", r, n) : $t(J, n, r);
            }), t.rejection = _ || st(t) ? rt : nt, e.error)) throw e.value;
          });
        },
            st = function st(t) {
          return t.rejection !== nt && !t.parent;
        },
            lt = function lt(t) {
          w.call($, function () {
            var e = t.facade;
            _ ? W.emit("rejectionHandled", e) : $t(X, e, t.value);
          });
        },
            ft = function ft(t, e, n) {
          return function (r) {
            t(e, r, n);
          };
        },
            pt = function pt(t, e, n) {
          t.done || (t.done = !0, n && (t = n), t.value = e, t.state = et, ut(t, !0));
        },
            ht = function ht(t, e, n) {
          if (!t.done) {
            t.done = !0, n && (t = n);

            try {
              if (t.facade === e) throw K("Promise can't be resolved itself");
              var r = at(e);
              r ? S(function () {
                var n = {
                  done: !1
                };

                try {
                  r.call(e, ft(ht, n, t), ft(pt, n, t));
                } catch (d) {
                  pt(n, d, t);
                }
              }) : (t.value = e, t.state = tt, ut(t, !1));
            } catch (d) {
              pt({
                done: !1
              }, d, t);
            }
          }
        };

        if (it && (_U = function U(t) {
          m(this, _U, D), g(t), r.call(this);
          var e = L(this);

          try {
            t(ft(ht, e), ft(pt, e));
          } catch (n) {
            pt(e, n);
          }
        }, V = _U.prototype, r = function r(t) {
          F(this, {
            type: D,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: [],
            rejection: !1,
            state: Q,
            value: void 0
          });
        }, r.prototype = f(V, {
          then: function then(t, e) {
            var n = B(this),
                r = z(O(this, _U));
            return r.ok = "function" != typeof t || t, r.fail = "function" == typeof e && e, r.domain = _ ? W.domain : void 0, n.parent = !0, n.reactions.push(r), n.state != Q && ut(n, !1), r.promise;
          },
          catch: function _catch(t) {
            return this.then(void 0, t);
          }
        }), d = function d() {
          var t = new r(),
              e = L(t);
          this.promise = t, this.resolve = ft(ht, e), this.reject = ft(pt, e);
        }, I.f = z = function z(t) {
          return t === _U || t === i ? new d(t) : Y(t);
        }, !u && "function" == typeof s && G !== Object.prototype)) {
          o = G.then, dt || (l(G, "then", function (t, e) {
            var n = this;
            return new _U(function (t, e) {
              o.call(n, t, e);
            }).then(t, e);
          }, {
            unsafe: !0
          }), l(G, "catch", V["catch"], {
            unsafe: !0
          }));

          try {
            delete G.constructor;
          } catch (vt) {}

          p && p(G, V);
        }

        a({
          global: !0,
          wrap: !0,
          forced: it
        }, {
          Promise: _U
        }), h(_U, D, !1, !0), v(D), i = c(D), a({
          target: D,
          stat: !0,
          forced: it
        }, {
          reject: function reject(t) {
            var e = z(this);
            return e.reject.call(void 0, t), e.promise;
          }
        }), a({
          target: D,
          stat: !0,
          forced: u || it
        }, {
          resolve: function resolve(t) {
            return E(u && this === i ? _U : this, t);
          }
        }), a({
          target: D,
          stat: !0,
          forced: ot
        }, {
          all: function all(t) {
            var e = this,
                n = z(e),
                r = n.resolve,
                d = n.reject,
                i = N(function () {
              var n = g(e.resolve),
                  i = [],
                  o = 0,
                  a = 1;
              C(t, function (t) {
                var u = o++,
                    $ = !1;
                i.push(void 0), a++, n.call(e, t).then(function (t) {
                  $ || ($ = !0, i[u] = t, --a || r(i));
                }, d);
              }), --a || r(i);
            });
            return i.error && d(i.value), n.promise;
          },
          race: function race(t) {
            var e = this,
                n = z(e),
                r = n.reject,
                d = N(function () {
              var d = g(e.resolve);
              C(t, function (t) {
                d.call(e, t).then(n.resolve, r);
              });
            });
            return d.error && r(d.value), n.promise;
          }
        });
      },
      4603: function _(t, e, n) {
        var r = n(9781),
            d = n(7854),
            i = n(4705),
            o = n(9587),
            a = n(3070).f,
            u = n(8006).f,
            $ = n(7850),
            c = n(7066),
            s = n(2999),
            l = n(1320),
            f = n(7293),
            p = n(9909).enforce,
            h = n(6340),
            v = n(5112),
            y = v("match"),
            g = d.RegExp,
            m = g.prototype,
            b = /a/g,
            C = /a/g,
            x = new g(b) !== b,
            O = s.UNSUPPORTED_Y,
            w = r && i("RegExp", !x || O || f(function () {
          return C[y] = !1, g(b) != b || g(C) == C || "/a/i" != g(b, "i");
        }));

        if (w) {
          var S = function S(t, e) {
            var n,
                r = this instanceof S,
                d = $(t),
                i = void 0 === e;
            if (!r && d && t.constructor === S && i) return t;
            x ? d && !i && (t = t.source) : t instanceof S && (i && (e = c.call(t)), t = t.source), O && (n = !!e && e.indexOf("y") > -1, n && (e = e.replace(/y/g, "")));
            var a = o(x ? new g(t, e) : g(t, e), r ? this : m, S);

            if (O && n) {
              var u = p(a);
              u.sticky = !0;
            }

            return a;
          },
              E = function E(t) {
            t in S || a(S, t, {
              configurable: !0,
              get: function get() {
                return g[t];
              },
              set: function set(e) {
                g[t] = e;
              }
            });
          },
              P = u(g),
              I = 0;

          while (P.length > I) {
            E(P[I++]);
          }

          m.constructor = S, S.prototype = m, l(d, "RegExp", S);
        }

        h("RegExp");
      },
      4916: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(2261);
        r({
          target: "RegExp",
          proto: !0,
          forced: /./.exec !== d
        }, {
          exec: d
        });
      },
      9714: function _(t, e, n) {
        "use strict";

        var r = n(1320),
            d = n(9670),
            i = n(7293),
            o = n(7066),
            a = "toString",
            u = RegExp.prototype,
            $ = u[a],
            c = i(function () {
          return "/a/b" != $.call({
            source: "a",
            flags: "b"
          });
        }),
            s = $.name != a;
        (c || s) && r(RegExp.prototype, a, function () {
          var t = d(this),
              e = String(t.source),
              n = t.flags,
              r = String(void 0 === n && t instanceof RegExp && !("flags" in u) ? o.call(t) : n);
          return "/" + e + "/" + r;
        }, {
          unsafe: !0
        });
      },
      2023: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(3929),
            i = n(4488),
            o = n(4964);
        r({
          target: "String",
          proto: !0,
          forced: !o("includes")
        }, {
          includes: function includes(t) {
            return !!~String(i(this)).indexOf(d(t), arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      },
      8783: function _(t, e, n) {
        "use strict";

        var r = n(8710).charAt,
            d = n(9909),
            i = n(654),
            o = "String Iterator",
            a = d.set,
            u = d.getterFor(o);
        i(String, "String", function (t) {
          a(this, {
            type: o,
            string: String(t),
            index: 0
          });
        }, function () {
          var t,
              e = u(this),
              n = e.string,
              d = e.index;
          return d >= n.length ? {
            value: void 0,
            done: !0
          } : (t = r(n, d), e.index += t.length, {
            value: t,
            done: !1
          });
        });
      },
      4723: function _(t, e, n) {
        "use strict";

        var r = n(7007),
            d = n(9670),
            i = n(7466),
            o = n(4488),
            a = n(1530),
            u = n(7651);
        r("match", 1, function (t, e, n) {
          return [function (e) {
            var n = o(this),
                r = void 0 == e ? void 0 : e[t];
            return void 0 !== r ? r.call(e, n) : new RegExp(e)[t](String(n));
          }, function (t) {
            var r = n(e, t, this);
            if (r.done) return r.value;
            var o = d(t),
                $ = String(this);
            if (!o.global) return u(o, $);
            var c = o.unicode;
            o.lastIndex = 0;
            var s,
                l = [],
                f = 0;

            while (null !== (s = u(o, $))) {
              var p = String(s[0]);
              l[f] = p, "" === p && (o.lastIndex = a($, i(o.lastIndex), c)), f++;
            }

            return 0 === f ? null : l;
          }];
        });
      },
      3123: function _(t, e, n) {
        "use strict";

        var r = n(7007),
            d = n(7850),
            i = n(9670),
            o = n(4488),
            a = n(6707),
            u = n(1530),
            $ = n(7466),
            c = n(7651),
            s = n(2261),
            l = n(2999),
            f = l.UNSUPPORTED_Y,
            p = [].push,
            h = Math.min,
            v = 4294967295;
        r("split", 2, function (t, e, n) {
          var r;
          return r = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, n) {
            var r = String(o(this)),
                i = void 0 === n ? v : n >>> 0;
            if (0 === i) return [];
            if (void 0 === t) return [r];
            if (!d(t)) return e.call(r, t, i);
            var a,
                u,
                $,
                c = [],
                l = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""),
                f = 0,
                h = new RegExp(t.source, l + "g");

            while (a = s.call(h, r)) {
              if (u = h.lastIndex, u > f && (c.push(r.slice(f, a.index)), a.length > 1 && a.index < r.length && p.apply(c, a.slice(1)), $ = a[0].length, f = u, c.length >= i)) break;
              h.lastIndex === a.index && h.lastIndex++;
            }

            return f === r.length ? !$ && h.test("") || c.push("") : c.push(r.slice(f)), c.length > i ? c.slice(0, i) : c;
          } : "0".split(void 0, 0).length ? function (t, n) {
            return void 0 === t && 0 === n ? [] : e.call(this, t, n);
          } : e, [function (e, n) {
            var d = o(this),
                i = void 0 == e ? void 0 : e[t];
            return void 0 !== i ? i.call(e, d, n) : r.call(String(d), e, n);
          }, function (t, d) {
            var o = n(r, t, this, d, r !== e);
            if (o.done) return o.value;
            var s = i(t),
                l = String(this),
                p = a(s, RegExp),
                y = s.unicode,
                g = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (f ? "g" : "y"),
                m = new p(f ? "^(?:" + s.source + ")" : s, g),
                b = void 0 === d ? v : d >>> 0;
            if (0 === b) return [];
            if (0 === l.length) return null === c(m, l) ? [l] : [];
            var C = 0,
                x = 0,
                O = [];

            while (x < l.length) {
              m.lastIndex = f ? 0 : x;
              var w,
                  S = c(m, f ? l.slice(x) : l);
              if (null === S || (w = h($(m.lastIndex + (f ? x : 0)), l.length)) === C) x = u(l, x, y);else {
                if (O.push(l.slice(C, x)), O.length === b) return O;

                for (var E = 1; E <= S.length - 1; E++) {
                  if (O.push(S[E]), O.length === b) return O;
                }

                x = C = w;
              }
            }

            return O.push(l.slice(C)), O;
          }];
        }, f);
      },
      6755: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(1236).f,
            i = n(7466),
            o = n(3929),
            a = n(4488),
            u = n(4964),
            $ = n(1913),
            c = "".startsWith,
            s = Math.min,
            l = u("startsWith"),
            f = !$ && !l && !!function () {
          var t = d(String.prototype, "startsWith");
          return t && !t.writable;
        }();
        r({
          target: "String",
          proto: !0,
          forced: !f && !l
        }, {
          startsWith: function startsWith(t) {
            var e = String(a(this));
            o(t);
            var n = i(s(arguments.length > 1 ? arguments[1] : void 0, e.length)),
                r = String(t);
            return c ? c.call(e, r, n) : e.slice(n, n + r.length) === r;
          }
        });
      },
      3210: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(3111).trim,
            i = n(6091);
        r({
          target: "String",
          proto: !0,
          forced: i("trim")
        }, {
          trim: function trim() {
            return d(this);
          }
        });
      },
      1817: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(9781),
            i = n(7854),
            o = n(6656),
            a = n(111),
            u = n(3070).f,
            $ = n(9920),
            c = i.Symbol;

        if (d && "function" == typeof c && (!("description" in c.prototype) || void 0 !== c().description)) {
          var s = {},
              l = function l() {
            var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
                e = this instanceof l ? new c(t) : void 0 === t ? c() : c(t);
            return "" === t && (s[e] = !0), e;
          };

          $(l, c);
          var f = l.prototype = c.prototype;
          f.constructor = l;
          var p = f.toString,
              h = "Symbol(test)" == String(c("test")),
              v = /^Symbol\((.*)\)[^)]+$/;
          u(f, "description", {
            configurable: !0,
            get: function get() {
              var t = a(this) ? this.valueOf() : this,
                  e = p.call(t);
              if (o(s, t)) return "";
              var n = h ? e.slice(7, -1) : e.replace(v, "$1");
              return "" === n ? void 0 : n;
            }
          }), r({
            global: !0,
            forced: !0
          }, {
            Symbol: l
          });
        }
      },
      2165: function _(t, e, n) {
        var r = n(7235);
        r("iterator");
      },
      2526: function _(t, e, n) {
        "use strict";

        var r = n(2109),
            d = n(7854),
            i = n(5005),
            o = n(1913),
            a = n(9781),
            u = n(133),
            $ = n(3307),
            c = n(7293),
            s = n(6656),
            l = n(3157),
            f = n(111),
            p = n(9670),
            h = n(7908),
            v = n(5656),
            y = n(7593),
            g = n(9114),
            m = n(30),
            b = n(1956),
            C = n(8006),
            x = n(1156),
            O = n(5181),
            w = n(1236),
            S = n(3070),
            E = n(5296),
            P = n(8880),
            I = n(1320),
            N = n(2309),
            k = n(6200),
            T = n(3501),
            A = n(9711),
            j = n(5112),
            _ = n(6061),
            M = n(7235),
            R = n(8003),
            D = n(9909),
            L = n(2092).forEach,
            F = k("hidden"),
            B = "Symbol",
            G = "prototype",
            U = j("toPrimitive"),
            V = D.set,
            K = D.getterFor(B),
            H = Object[G],
            _W = d.Symbol,
            z = i("JSON", "stringify"),
            Y = w.f,
            Z = S.f,
            q = x.f,
            J = E.f,
            X = N("symbols"),
            Q = N("op-symbols"),
            tt = N("string-to-symbol-registry"),
            et = N("symbol-to-string-registry"),
            nt = N("wks"),
            rt = d.QObject,
            dt = !rt || !rt[G] || !rt[G].findChild,
            it = a && c(function () {
          return 7 != m(Z({}, "a", {
            get: function get() {
              return Z(this, "a", {
                value: 7
              }).a;
            }
          })).a;
        }) ? function (t, e, n) {
          var r = Y(H, e);
          r && delete H[e], Z(t, e, n), r && t !== H && Z(H, e, r);
        } : Z,
            ot = function ot(t, e) {
          var n = X[t] = m(_W[G]);
          return V(n, {
            type: B,
            tag: t,
            description: e
          }), a || (n.description = e), n;
        },
            at = $ ? function (t) {
          return "symbol" == _typeof(t);
        } : function (t) {
          return Object(t) instanceof _W;
        },
            ut = function ut(t, e, n) {
          t === H && ut(Q, e, n), p(t);
          var r = y(e, !0);
          return p(n), s(X, r) ? (n.enumerable ? (s(t, F) && t[F][r] && (t[F][r] = !1), n = m(n, {
            enumerable: g(0, !1)
          })) : (s(t, F) || Z(t, F, g(1, {})), t[F][r] = !0), it(t, r, n)) : Z(t, r, n);
        },
            $t = function $t(t, e) {
          p(t);
          var n = v(e),
              r = b(n).concat(pt(n));
          return L(r, function (e) {
            a && !st.call(n, e) || ut(t, e, n[e]);
          }), t;
        },
            ct = function ct(t, e) {
          return void 0 === e ? m(t) : $t(m(t), e);
        },
            st = function st(t) {
          var e = y(t, !0),
              n = J.call(this, e);
          return !(this === H && s(X, e) && !s(Q, e)) && (!(n || !s(this, e) || !s(X, e) || s(this, F) && this[F][e]) || n);
        },
            lt = function lt(t, e) {
          var n = v(t),
              r = y(e, !0);

          if (n !== H || !s(X, r) || s(Q, r)) {
            var d = Y(n, r);
            return !d || !s(X, r) || s(n, F) && n[F][r] || (d.enumerable = !0), d;
          }
        },
            ft = function ft(t) {
          var e = q(v(t)),
              n = [];
          return L(e, function (t) {
            s(X, t) || s(T, t) || n.push(t);
          }), n;
        },
            pt = function pt(t) {
          var e = t === H,
              n = q(e ? Q : v(t)),
              r = [];
          return L(n, function (t) {
            !s(X, t) || e && !s(H, t) || r.push(X[t]);
          }), r;
        };

        if (u || (_W = function W() {
          if (this instanceof _W) throw TypeError("Symbol is not a constructor");

          var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
              e = A(t),
              n = function n(t) {
            this === H && n.call(Q, t), s(this, F) && s(this[F], e) && (this[F][e] = !1), it(this, e, g(1, t));
          };

          return a && dt && it(H, e, {
            configurable: !0,
            set: n
          }), ot(e, t);
        }, I(_W[G], "toString", function () {
          return K(this).tag;
        }), I(_W, "withoutSetter", function (t) {
          return ot(A(t), t);
        }), E.f = st, S.f = ut, w.f = lt, C.f = x.f = ft, O.f = pt, _.f = function (t) {
          return ot(j(t), t);
        }, a && (Z(_W[G], "description", {
          configurable: !0,
          get: function get() {
            return K(this).description;
          }
        }), o || I(H, "propertyIsEnumerable", st, {
          unsafe: !0
        }))), r({
          global: !0,
          wrap: !0,
          forced: !u,
          sham: !u
        }, {
          Symbol: _W
        }), L(b(nt), function (t) {
          M(t);
        }), r({
          target: B,
          stat: !0,
          forced: !u
        }, {
          for: function _for(t) {
            var e = String(t);
            if (s(tt, e)) return tt[e];

            var n = _W(e);

            return tt[e] = n, et[n] = e, n;
          },
          keyFor: function keyFor(t) {
            if (!at(t)) throw TypeError(t + " is not a symbol");
            if (s(et, t)) return et[t];
          },
          useSetter: function useSetter() {
            dt = !0;
          },
          useSimple: function useSimple() {
            dt = !1;
          }
        }), r({
          target: "Object",
          stat: !0,
          forced: !u,
          sham: !a
        }, {
          create: ct,
          defineProperty: ut,
          defineProperties: $t,
          getOwnPropertyDescriptor: lt
        }), r({
          target: "Object",
          stat: !0,
          forced: !u
        }, {
          getOwnPropertyNames: ft,
          getOwnPropertySymbols: pt
        }), r({
          target: "Object",
          stat: !0,
          forced: c(function () {
            O.f(1);
          })
        }, {
          getOwnPropertySymbols: function getOwnPropertySymbols(t) {
            return O.f(h(t));
          }
        }), z) {
          var ht = !u || c(function () {
            var t = _W();

            return "[null]" != z([t]) || "{}" != z({
              a: t
            }) || "{}" != z(Object(t));
          });
          r({
            target: "JSON",
            stat: !0,
            forced: ht
          }, {
            stringify: function stringify(t, e, n) {
              var r,
                  d = [t],
                  i = 1;

              while (arguments.length > i) {
                d.push(arguments[i++]);
              }

              if (r = e, (f(e) || void 0 !== t) && !at(t)) return l(e) || (e = function e(t, _e2) {
                if ("function" == typeof r && (_e2 = r.call(this, t, _e2)), !at(_e2)) return _e2;
              }), d[1] = e, z.apply(null, d);
            }
          });
        }

        _W[G][U] || P(_W[G], U, _W[G].valueOf), R(_W, B), T[F] = !0;
      },
      4747: function _(t, e, n) {
        var r = n(7854),
            d = n(8324),
            i = n(8533),
            o = n(8880);

        for (var a in d) {
          var u = r[a],
              $ = u && u.prototype;
          if ($ && $.forEach !== i) try {
            o($, "forEach", i);
          } catch (c) {
            $.forEach = i;
          }
        }
      },
      3948: function _(t, e, n) {
        var r = n(7854),
            d = n(8324),
            i = n(6992),
            o = n(8880),
            a = n(5112),
            u = a("iterator"),
            $ = a("toStringTag"),
            c = i.values;

        for (var s in d) {
          var l = r[s],
              f = l && l.prototype;

          if (f) {
            if (f[u] !== c) try {
              o(f, u, c);
            } catch (h) {
              f[u] = c;
            }
            if (f[$] || o(f, $, s), d[s]) for (var p in i) {
              if (f[p] !== i[p]) try {
                o(f, p, i[p]);
              } catch (h) {
                f[p] = i[p];
              }
            }
          }
        }
      }
    },
        e = {};

    function n(r) {
      var d = e[r];
      if (void 0 !== d) return d.exports;
      var i = e[r] = {
        exports: {}
      };
      return t[r].call(i.exports, i, i.exports, n), i.exports;
    }

    !function () {
      n.d = function (t, e) {
        for (var r in e) {
          n.o(e, r) && !n.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: e[r]
          });
        }
      };
    }(), function () {
      n.g = function () {
        if ("object" === (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;

        try {
          return this || new Function("return this")();
        } catch (t) {
          if ("object" === (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
        }
      }();
    }(), function () {
      n.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      };
    }(), function () {
      n.r = function (t) {
        "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(t, "__esModule", {
          value: !0
        });
      };
    }(), function () {
      n.p = "";
    }();
    var r = {};
    return function () {
      "use strict";

      if (n.r(r), n.d(r, {
        VueTelInput: function VueTelInput() {
          return Qe;
        },
        default: function _default() {
          return an;
        },
        install: function install() {
          return nn;
        }
      }), "undefined" !== typeof window) {
        var t = window.document.currentScript,
            e = n(7679);
        t = e(), "currentScript" in document || Object.defineProperty(document, "currentScript", {
          get: e
        });
        var d = t && t.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);
        d && (n.p = d[1]);
      }

      n(7941), n(2526), n(7327), n(5003), n(4747), n(9337);

      function i(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      function o(t, e) {
        var n = Object.keys(t);

        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(t);
          e && (r = r.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })), n.push.apply(n, r);
        }

        return n;
      }

      function a(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {};
          e % 2 ? o(Object(n), !0).forEach(function (e) {
            i(t, e, n[e]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
          });
        }

        return t;
      }

      function u(t, e) {
        if (null == t) return {};
        var n,
            r,
            d = {},
            i = Object.keys(t);

        for (r = 0; r < i.length; r++) {
          n = i[r], e.indexOf(n) >= 0 || (d[n] = t[n]);
        }

        return d;
      }

      function $(t, e) {
        if (null == t) return {};
        var n,
            r,
            d = u(t, e);

        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(t);

          for (r = 0; r < i.length; r++) {
            n = i[r], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (d[n] = t[n]);
          }
        }

        return d;
      }

      function c(t) {
        if (Array.isArray(t)) return t;
      }

      n(1817), n(1539), n(2165), n(6992), n(8783), n(3948);

      function s(t, e) {
        var n = null == t ? null : "undefined" !== typeof Symbol && t[Symbol.iterator] || t["@@iterator"];

        if (null != n) {
          var r,
              d,
              i = [],
              o = !0,
              a = !1;

          try {
            for (n = n.call(t); !(o = (r = n.next()).done); o = !0) {
              if (i.push(r.value), e && i.length === e) break;
            }
          } catch (u) {
            a = !0, d = u;
          } finally {
            try {
              o || null == n["return"] || n["return"]();
            } finally {
              if (a) throw d;
            }
          }

          return i;
        }
      }

      n(7042), n(8309), n(1038);

      function l(t, e) {
        (null == e || e > t.length) && (e = t.length);

        for (var n = 0, r = new Array(e); n < e; n++) {
          r[n] = t[n];
        }

        return r;
      }

      function f(t, e) {
        if (t) {
          if ("string" === typeof t) return l(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(t, e) : void 0;
        }
      }

      function p() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function h(t, e) {
        return c(t) || s(t, e) || f(t, e) || p();
      }

      n(8674), n(9714), n(4603), n(4916), n(9653), n(2222), n(6699), n(2023), n(3123), n(9601), n(1249);
      var v = [["Afghanistan (‫افغانستان‬‎)", "af", "93"], ["Albania (Shqipëri)", "al", "355"], ["Algeria (‫الجزائر‬‎)", "dz", "213"], ["American Samoa", "as", "1684"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1264"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54"], ["Armenia (Հայաստան)", "am", "374"], ["Aruba", "aw", "297"], ["Australia", "au", "61"], ["Austria (Österreich)", "at", "43"], ["Azerbaijan (Azərbaycan)", "az", "994"], ["Bahamas", "bs", "1242"], ["Bahrain (‫البحرين‬‎)", "bh", "973"], ["Bangladesh (বাংলাদেশ)", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus (Беларусь)", "by", "375"], ["Belgium (België)", "be", "32"], ["Belize", "bz", "501"], ["Benin (Bénin)", "bj", "229"], ["Bermuda", "bm", "1441"], ["Bhutan (འབྲུག)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1284"], ["Brunei", "bn", "673"], ["Bulgaria (България)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (កម្ពុជា)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1"], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599"], ["Cayman Islands", "ky", "1345"], ["Central African Republic (République centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (中国)", "cn", "86"], ["Christmas Island", "cx", "61"], ["Cocos (Keeling) Islands", "cc", "61"], ["Colombia", "co", "57"], ["Comoros (‫جزر القمر‬‎)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["Côte d’Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599"], ["Cyprus (Κύπρος)", "cy", "357"], ["Czech Republic (Česká republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1767"], ["Dominican Republic (República Dominicana)", "do", "1"], ["Ecuador", "ec", "593"], ["Egypt (‫مصر‬‎)", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (Føroyar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358"], ["France", "fr", "33"], ["French Guiana (Guyane française)", "gf", "594"], ["French Polynesia (Polynésie française)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (საქართველო)", "ge", "995"], ["Germany (Deutschland)", "de", "49"], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (Ελλάδα)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590"], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1], ["Guinea (Guinée)", "gn", "224"], ["Guinea-Bissau (Guiné Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong (香港)", "hk", "852"], ["Hungary (Magyarország)", "hu", "36"], ["Iceland (Ísland)", "is", "354"], ["India (भारत)", "in", "91"], ["Indonesia", "id", "62"], ["Iran (‫ایران‬‎)", "ir", "98"], ["Iraq (‫العراق‬‎)", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44"], ["Israel (‫ישראל‬‎)", "il", "972"], ["Italy (Italia)", "it", "39"], ["Jamaica", "jm", "1876"], ["Japan (日本)", "jp", "81"], ["Jersey", "je", "44"], ["Jordan (‫الأردن‬‎)", "jo", "962"], ["Kazakhstan (Казахстан)", "kz", "7"], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait (‫الكويت‬‎)", "kw", "965"], ["Kyrgyzstan (Кыргызстан)", "kg", "996"], ["Laos (ລາວ)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (‫لبنان‬‎)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (‫ليبيا‬‎)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (澳門)", "mo", "853"], ["Macedonia (FYROM) (Македонија)", "mk", "389"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (‫موريتانيا‬‎)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mayotte", "yt", "262"], ["Mexico (México)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (Монгол)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1664"], ["Morocco (‫المغرب‬‎)", "ma", "212"], ["Mozambique (Moçambique)", "mz", "258"], ["Myanmar (Burma) (မြန်မာ)", "mm", "95"], ["Namibia (Namibië)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (नेपाल)", "np", "977"], ["Netherlands (Nederland)", "nl", "31"], ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"], ["Northern Mariana Islands", "mp", "1670"], ["Norway (Norge)", "no", "47"], ["Oman (‫عُمان‬‎)", "om", "968"], ["Pakistan (‫پاکستان‬‎)", "pk", "92"], ["Palau", "pw", "680"], ["Palestine (‫فلسطين‬‎)", "ps", "970"], ["Panama (Panamá)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Perú)", "pe", "51"], ["Philippines", "ph", "63"], ["Poland (Polska)", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1"], ["Qatar (‫قطر‬‎)", "qa", "974"], ["Réunion (La Réunion)", "re", "262"], ["Romania (România)", "ro", "40"], ["Russia (Россия)", "ru", "7"], ["Rwanda", "rw", "250"], ["Saint Barthélemy", "bl", "590"], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Martin (Saint-Martin (partie française))", "mf", "590"], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"], ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"], ["Senegal (Sénégal)", "sn", "221"], ["Serbia (Србија)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1721"], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (대한민국)", "kr", "82"], ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"], ["Spain (España)", "es", "34"], ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"], ["Sudan (‫السودان‬‎)", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47"], ["Swaziland", "sz", "268"], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41"], ["Syria (‫سوريا‬‎)", "sy", "963"], ["Taiwan (台灣)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (ไทย)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia (‫تونس‬‎)", "tn", "216"], ["Turkey (Türkiye)", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1649"], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1340"], ["Uganda", "ug", "256"], ["Ukraine (Україна)", "ua", "380"], ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"], ["United Kingdom", "gb", "44"], ["United States", "us", "1"], ["Uruguay", "uy", "598"], ["Uzbekistan (Oʻzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Città del Vaticano)", "va", "39"], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna (Wallis-et-Futuna)", "wf", "681"], ["Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212"], ["Yemen (‫اليمن‬‎)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["Åland Islands", "ax", "358"]],
          y = v.map(function (t) {
        var e = h(t, 3),
            n = e[0],
            r = e[1],
            d = e[2];
        return {
          name: n,
          iso2: r.toUpperCase(),
          dialCode: d
        };
      });

      function g() {
        return fetch("https://ip2c.org/s").then(function (t) {
          return t.text();
        }).then(function (t) {
          var e = (t || "").toString();
          if (!e || "1" !== e[0]) throw new Error("unable to fetch the country");
          return e.substr(2, 2);
        });
      }

      function m(t, e) {
        if (t.setSelectionRange) t.focus(), t.setSelectionRange(e, e);else if (t.createTextRange) {
          var n = t.createTextRange();
          n.collapse(!0), n.moveEnd("character", e), n.moveStart("character", e), n.select();
        }
      }

      var b = [{
        name: "allCountries",
        type: Array,
        default: y,
        description: "All countries that are used in <code>libphonenumber-js</code>, can be overridden by this prop",
        inDemo: !1
      }, {
        name: "autoFormat",
        type: Boolean,
        default: !0,
        description: "Auto update the input to the formatted phone number when it's valid",
        inDemo: !0
      }, {
        name: "customValidate",
        type: [Boolean, RegExp],
        default: !1,
        description: "Custom validation RegExp for input",
        inDemo: !1
      }, {
        name: "defaultCountry",
        default: "",
        type: [String, Number],
        description: "Default country (by iso2 or dialCode), will override the country fetched from IP address of user",
        inDemo: !1
      }, {
        name: "disabled",
        default: !1,
        type: Boolean,
        description: "Disable <code>vue-tel-input</code>, including the input & flag dropdown",
        inDemo: !1
      }, {
        name: "autoDefaultCountry",
        default: !0,
        type: Boolean,
        description: "To fetch default country based on IP address of user",
        inDemo: !1
      }, {
        name: "dropdownOptions",
        type: Object,
        description: "Options for dropdown, see below",
        inDemo: !1
      }, {
        name: "dropdownOptions.disabled",
        default: !1,
        type: Boolean,
        description: "Disable dropdown",
        inDemo: !1
      }, {
        name: "dropdownOptions.showDialCodeInList",
        default: !0,
        type: Boolean,
        description: "Show dial code in the dropdown list",
        inDemo: !0
      }, {
        name: "dropdownOptions.showDialCodeInSelection",
        default: !1,
        type: Boolean,
        description: "Show dial code in the dropdown selection",
        inDemo: !0
      }, {
        name: "dropdownOptions.showFlags",
        default: !0,
        type: Boolean,
        description: "Show flags in the dropdown selection and list",
        inDemo: !0
      }, {
        name: "dropdownOptions.showSearchBox",
        default: !1,
        type: Boolean,
        description: "Show country search box",
        inDemo: !0
      }, {
        name: "dropdownOptions.tabindex",
        default: 0,
        type: Number,
        description: "Native dropdown <code>tabindex</code> attribute",
        inDemo: !1
      }, {
        name: "dropdownOptions.width",
        default: "390px",
        type: String,
        description: "Specify dropdown width"
      }, {
        name: "ignoredCountries",
        default: [],
        type: Array,
        description: "List of countries will NOT be shown on the dropdown",
        inDemo: !1
      }, {
        name: "inputOptions",
        type: Object,
        description: "Options for input, see below",
        inDemo: !1
      }, {
        name: "inputOptions.autocomplete",
        type: String,
        default: "on",
        description: "Native input <code>autocomplete</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.autofocus",
        type: Boolean,
        default: !1,
        description: "Native input <code>autofocus</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.aria-describedby",
        default: "",
        type: String,
        description: "Native input <code>aria-describedby</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.id",
        default: "",
        type: String,
        description: "Native input <code>id</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.maxlength",
        default: 25,
        type: Number,
        description: "Native input <code>maxlength</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.name",
        default: "telephone",
        type: String,
        description: "Native input <code>name</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.showDialCode",
        default: !1,
        type: Boolean,
        description: "Show dial code in input",
        inDemo: !0
      }, {
        name: "inputOptions.placeholder",
        default: "Enter a phone number",
        type: String,
        description: "Placeholder for the input",
        inDemo: !1
      }, {
        name: "inputOptions.readonly",
        default: !1,
        type: Boolean,
        description: "Native input <code>readonly</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.required",
        default: !1,
        type: Boolean,
        description: "Native input <code>required</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.tabindex",
        default: 0,
        type: Number,
        description: "Native input <code>tabindex</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.type",
        default: "tel",
        type: String,
        description: "Native input <code>type</code> attribute",
        inDemo: !1
      }, {
        name: "inputOptions.styleClasses",
        default: "",
        type: [String, Array, Object],
        description: "Custom classes for the <code>input</code>",
        inDemo: !1
      }, {
        name: "invalidMsg",
        default: "",
        type: String,
        description: "",
        inDemo: !1
      }, {
        name: "mode",
        default: "auto",
        type: String,
        description: "Allowed values: <code>'auto'</code> (Default set by phone),  <code>'international'</code> (Format number with the dial code i.e. + 61), <code>'national'</code> (Format number without dial code i.e. 0321232)",
        inDemo: !0,
        options: ["auto", "national", "international"]
      }, {
        name: "onlyCountries",
        default: [],
        type: Array,
        description: "List of countries will be shown on the dropdown",
        inDemo: !1
      }, {
        name: "preferredCountries",
        default: [],
        type: Array,
        description: "Preferred countries list, will be on top of the dropdown",
        inDemo: !1
      }, {
        name: "styleClasses",
        default: "",
        type: [String, Array, Object],
        description: "Custom classes for the wrapper",
        inDemo: !1
      }, {
        name: "validCharactersOnly",
        default: !1,
        type: Boolean,
        description: "Only allow valid characters in a phone number (will also verify in <code>mounted</code>, so phone number with invalid characters will be shown as an empty string)",
        inDemo: !1
      }],
          C = [].concat(b).reduce(function (t, e) {
        if (e.name.includes(".")) {
          var n = e.name.split("."),
              r = h(n, 2),
              d = r[0],
              o = r[1];
          t[d] ? Object.assign(t[d], i({}, o, e.default)) : Object.assign(t, i({}, d, i({}, o, e.default)));
        } else Object.assign(t, i({}, e.name, e.default));

        return t;
      }, {}),
          x = {
        options: a({}, C)
      },
          O = function O() {
        var t = this,
            e = t.$createElement,
            n = t._self._c || e;
        return n("div", {
          class: ["vue-tel-input", t.styleClasses, {
            disabled: t.disabled
          }]
        }, [n("div", {
          directives: [{
            name: "click-outside",
            rawName: "v-click-outside",
            value: t.clickedOutside,
            expression: "clickedOutside"
          }],
          class: ["vti__dropdown", {
            open: t.open,
            disabled: t.dropdownOptions.disabled
          }],
          attrs: {
            "aria-label": "Country Code Selector",
            "aria-haspopup": "listbox",
            "aria-expanded": t.open,
            role: "button",
            tabindex: t.dropdownOptions.tabindex
          },
          on: {
            keydown: [t.keyboardNav, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "space", 32, e.key, [" ", "Spacebar"]) ? null : t.toggleDropdown.apply(null, arguments);
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "esc", 27, e.key, ["Esc", "Escape"]) ? null : t.reset.apply(null, arguments);
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "tab", 9, e.key, "Tab") ? null : t.reset.apply(null, arguments);
            }],
            click: t.toggleDropdown
          }
        }, [n("span", {
          staticClass: "vti__selection"
        }, [t.dropdownOptions.showFlags ? n("span", {
          class: ["vti__flag", t.activeCountryCode.toLowerCase()]
        }) : t._e(), t.dropdownOptions.showDialCodeInSelection ? n("span", {
          staticClass: "vti__country-code"
        }, [t._v(" +" + t._s(t.activeCountry && t.activeCountry.dialCode) + " ")]) : t._e(), t._t("arrow-icon", function () {
          return [n("span", {
            staticClass: "vti__dropdown-arrow"
          }, [t._v(t._s(t.open ? "▲" : "▼"))])];
        }, {
          open: t.open
        })], 2), t.open ? n("ul", {
          ref: "list",
          staticClass: "vti__dropdown-list",
          class: t.dropdownOpenDirection,
          style: {
            width: t.dropdownOptions.width
          },
          attrs: {
            role: "listbox"
          }
        }, [t.dropdownOptions.showSearchBox ? n("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: t.searchQuery,
            expression: "searchQuery"
          }],
          staticClass: "vti__input vti__search_box",
          attrs: {
            "aria-label": "Search by country name or country code",
            placeholder: t.sortedCountries.length ? t.sortedCountries[0].name : "",
            type: "text"
          },
          domProps: {
            value: t.searchQuery
          },
          on: {
            click: function click(t) {
              t.stopPropagation();
            },
            input: function input(e) {
              e.target.composing || (t.searchQuery = e.target.value);
            }
          }
        }) : t._e(), t._l(t.sortedCountries, function (e, r) {
          return n("li", {
            key: e.iso2 + (e.preferred ? "-preferred" : ""),
            class: ["vti__dropdown-item", t.getItemClass(r, e.iso2)],
            attrs: {
              role: "option",
              tabindex: "-1",
              "aria-selected": t.activeCountryCode === e.iso2 && !e.preferred
            },
            on: {
              click: function click(n) {
                return t.choose(e);
              },
              mousemove: function mousemove(e) {
                t.selectedIndex = r;
              }
            }
          }, [n("div", {
            staticClass: "vti__flag-wrapper"
          }, [t.dropdownOptions.showFlags ? n("span", {
            class: ["vti__flag", e.iso2.toLowerCase()]
          }) : t._e()]), n("strong", [t._v(t._s(e.name))]), t.dropdownOptions.showDialCodeInList ? n("span", [t._v(" +" + t._s(e.dialCode) + " ")]) : t._e()]);
        })], 2) : t._e()]), "checkbox" === t.inputOptions.type ? n("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: t.phone,
            expression: "phone"
          }],
          ref: "input",
          class: ["vti__input", t.inputOptions.styleClasses],
          attrs: {
            autocomplete: t.inputOptions.autocomplete,
            autofocus: t.inputOptions.autofocus,
            disabled: t.disabled,
            id: t.inputOptions.id,
            maxlength: t.inputOptions.maxlength,
            name: t.inputOptions.name,
            placeholder: t.parsedPlaceholder,
            readonly: t.inputOptions.readonly,
            required: t.inputOptions.required,
            tabindex: t.inputOptions.tabindex,
            "aria-describedby": t.inputOptions["aria-describedby"],
            type: "checkbox"
          },
          domProps: {
            checked: Array.isArray(t.phone) ? t._i(t.phone, null) > -1 : t.phone
          },
          on: {
            blur: t.onBlur,
            focus: t.onFocus,
            input: t.onInput,
            keyup: [function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") ? null : t.onEnter.apply(null, arguments);
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "space", 32, e.key, [" ", "Spacebar"]) ? null : t.onSpace.apply(null, arguments);
            }],
            change: function change(e) {
              var n = t.phone,
                  r = e.target,
                  d = !!r.checked;

              if (Array.isArray(n)) {
                var i = null,
                    o = t._i(n, i);

                r.checked ? o < 0 && (t.phone = n.concat([i])) : o > -1 && (t.phone = n.slice(0, o).concat(n.slice(o + 1)));
              } else t.phone = d;
            }
          }
        }) : "radio" === t.inputOptions.type ? n("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: t.phone,
            expression: "phone"
          }],
          ref: "input",
          class: ["vti__input", t.inputOptions.styleClasses],
          attrs: {
            autocomplete: t.inputOptions.autocomplete,
            autofocus: t.inputOptions.autofocus,
            disabled: t.disabled,
            id: t.inputOptions.id,
            maxlength: t.inputOptions.maxlength,
            name: t.inputOptions.name,
            placeholder: t.parsedPlaceholder,
            readonly: t.inputOptions.readonly,
            required: t.inputOptions.required,
            tabindex: t.inputOptions.tabindex,
            "aria-describedby": t.inputOptions["aria-describedby"],
            type: "radio"
          },
          domProps: {
            checked: t._q(t.phone, null)
          },
          on: {
            blur: t.onBlur,
            focus: t.onFocus,
            input: t.onInput,
            keyup: [function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") ? null : t.onEnter.apply(null, arguments);
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "space", 32, e.key, [" ", "Spacebar"]) ? null : t.onSpace.apply(null, arguments);
            }],
            change: function change(e) {
              t.phone = null;
            }
          }
        }) : n("input", {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: t.phone,
            expression: "phone"
          }],
          ref: "input",
          class: ["vti__input", t.inputOptions.styleClasses],
          attrs: {
            autocomplete: t.inputOptions.autocomplete,
            autofocus: t.inputOptions.autofocus,
            disabled: t.disabled,
            id: t.inputOptions.id,
            maxlength: t.inputOptions.maxlength,
            name: t.inputOptions.name,
            placeholder: t.parsedPlaceholder,
            readonly: t.inputOptions.readonly,
            required: t.inputOptions.required,
            tabindex: t.inputOptions.tabindex,
            "aria-describedby": t.inputOptions["aria-describedby"],
            type: t.inputOptions.type
          },
          domProps: {
            value: t.phone
          },
          on: {
            blur: t.onBlur,
            focus: t.onFocus,
            input: [function (e) {
              e.target.composing || (t.phone = e.target.value);
            }, t.onInput],
            keyup: [function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "enter", 13, e.key, "Enter") ? null : t.onEnter.apply(null, arguments);
            }, function (e) {
              return !e.type.indexOf("key") && t._k(e.keyCode, "space", 32, e.key, [" ", "Spacebar"]) ? null : t.onSpace.apply(null, arguments);
            }]
          }
        }), t._t("icon-right")], 2);
      },
          w = [];

      function S(t) {
        if (Array.isArray(t)) return l(t);
      }

      function E(t) {
        if ("undefined" !== typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
      }

      function P() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      function I(t) {
        return S(t) || E(t) || f(t) || P();
      }

      n(3210), n(9826), n(4723), n(9600), n(4553), n(6755);
      var N = {
        version: 4,
        country_calling_codes: {
          1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"],
          7: ["RU", "KZ"],
          20: ["EG"],
          27: ["ZA"],
          30: ["GR"],
          31: ["NL"],
          32: ["BE"],
          33: ["FR"],
          34: ["ES"],
          36: ["HU"],
          39: ["IT", "VA"],
          40: ["RO"],
          41: ["CH"],
          43: ["AT"],
          44: ["GB", "GG", "IM", "JE"],
          45: ["DK"],
          46: ["SE"],
          47: ["NO", "SJ"],
          48: ["PL"],
          49: ["DE"],
          51: ["PE"],
          52: ["MX"],
          53: ["CU"],
          54: ["AR"],
          55: ["BR"],
          56: ["CL"],
          57: ["CO"],
          58: ["VE"],
          60: ["MY"],
          61: ["AU", "CC", "CX"],
          62: ["ID"],
          63: ["PH"],
          64: ["NZ"],
          65: ["SG"],
          66: ["TH"],
          81: ["JP"],
          82: ["KR"],
          84: ["VN"],
          86: ["CN"],
          90: ["TR"],
          91: ["IN"],
          92: ["PK"],
          93: ["AF"],
          94: ["LK"],
          95: ["MM"],
          98: ["IR"],
          211: ["SS"],
          212: ["MA", "EH"],
          213: ["DZ"],
          216: ["TN"],
          218: ["LY"],
          220: ["GM"],
          221: ["SN"],
          222: ["MR"],
          223: ["ML"],
          224: ["GN"],
          225: ["CI"],
          226: ["BF"],
          227: ["NE"],
          228: ["TG"],
          229: ["BJ"],
          230: ["MU"],
          231: ["LR"],
          232: ["SL"],
          233: ["GH"],
          234: ["NG"],
          235: ["TD"],
          236: ["CF"],
          237: ["CM"],
          238: ["CV"],
          239: ["ST"],
          240: ["GQ"],
          241: ["GA"],
          242: ["CG"],
          243: ["CD"],
          244: ["AO"],
          245: ["GW"],
          246: ["IO"],
          247: ["AC"],
          248: ["SC"],
          249: ["SD"],
          250: ["RW"],
          251: ["ET"],
          252: ["SO"],
          253: ["DJ"],
          254: ["KE"],
          255: ["TZ"],
          256: ["UG"],
          257: ["BI"],
          258: ["MZ"],
          260: ["ZM"],
          261: ["MG"],
          262: ["RE", "YT"],
          263: ["ZW"],
          264: ["NA"],
          265: ["MW"],
          266: ["LS"],
          267: ["BW"],
          268: ["SZ"],
          269: ["KM"],
          290: ["SH", "TA"],
          291: ["ER"],
          297: ["AW"],
          298: ["FO"],
          299: ["GL"],
          350: ["GI"],
          351: ["PT"],
          352: ["LU"],
          353: ["IE"],
          354: ["IS"],
          355: ["AL"],
          356: ["MT"],
          357: ["CY"],
          358: ["FI", "AX"],
          359: ["BG"],
          370: ["LT"],
          371: ["LV"],
          372: ["EE"],
          373: ["MD"],
          374: ["AM"],
          375: ["BY"],
          376: ["AD"],
          377: ["MC"],
          378: ["SM"],
          380: ["UA"],
          381: ["RS"],
          382: ["ME"],
          383: ["XK"],
          385: ["HR"],
          386: ["SI"],
          387: ["BA"],
          389: ["MK"],
          420: ["CZ"],
          421: ["SK"],
          423: ["LI"],
          500: ["FK"],
          501: ["BZ"],
          502: ["GT"],
          503: ["SV"],
          504: ["HN"],
          505: ["NI"],
          506: ["CR"],
          507: ["PA"],
          508: ["PM"],
          509: ["HT"],
          590: ["GP", "BL", "MF"],
          591: ["BO"],
          592: ["GY"],
          593: ["EC"],
          594: ["GF"],
          595: ["PY"],
          596: ["MQ"],
          597: ["SR"],
          598: ["UY"],
          599: ["CW", "BQ"],
          670: ["TL"],
          672: ["NF"],
          673: ["BN"],
          674: ["NR"],
          675: ["PG"],
          676: ["TO"],
          677: ["SB"],
          678: ["VU"],
          679: ["FJ"],
          680: ["PW"],
          681: ["WF"],
          682: ["CK"],
          683: ["NU"],
          685: ["WS"],
          686: ["KI"],
          687: ["NC"],
          688: ["TV"],
          689: ["PF"],
          690: ["TK"],
          691: ["FM"],
          692: ["MH"],
          850: ["KP"],
          852: ["HK"],
          853: ["MO"],
          855: ["KH"],
          856: ["LA"],
          880: ["BD"],
          886: ["TW"],
          960: ["MV"],
          961: ["LB"],
          962: ["JO"],
          963: ["SY"],
          964: ["IQ"],
          965: ["KW"],
          966: ["SA"],
          967: ["YE"],
          968: ["OM"],
          970: ["PS"],
          971: ["AE"],
          972: ["IL"],
          973: ["BH"],
          974: ["QA"],
          975: ["BT"],
          976: ["MN"],
          977: ["NP"],
          992: ["TJ"],
          993: ["TM"],
          994: ["AZ"],
          995: ["GE"],
          996: ["KG"],
          998: ["UZ"]
        },
        countries: {
          AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
          AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]],
          AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"],
          AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"],
          AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([457]\\d{6})$", "268$1", 0, "268"],
          AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2457]\\d{6})$", "264$1", 0, "264"],
          AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"],
          AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"],
          AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]],
          AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"],
          AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "1|([267]\\d{6})$", "684$1", 0, "684"],
          AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"],
          AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7,8}|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "0|(183[12])", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]]], "0011"],
          AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]],
          AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"],
          AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365|46", "1[28]|2|365(?:[0-46-9]|5[0-35-9])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"],
          BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"],
          BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "246$1", 0, "246"],
          BD: ["880", "00", "1\\d{9}|2\\d{7,8}|88\\d{4,6}|(?:8[0-79]|9\\d)\\d{4,8}|(?:[346]\\d|[57])\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"],
          BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"],
          BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]],
          BG: ["359", "00", "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"],
          BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]],
          BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]],
          BJ: ["229", "00", "[25689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25689]"]]]],
          BL: ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]],
          BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "441$1", 0, "441"],
          BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]],
          BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"],
          BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"],
          BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"],
          BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([3-8]\\d{6})$", "242$1", 0, "242"],
          BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]],
          BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]],
          BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"],
          BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]],
          CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}", [10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"], 0, 0, 0, ["600[2-9]\\d{6}"]]],
          CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]]], "0011"],
          CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
          CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]],
          CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["801"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]],
          CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"],
          CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]],
          CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]],
          CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]],
          CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]],
          CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "0|(1(?:[12]\\d|79)\\d\\d)", 0, 0, 0, 0, "00"],
          CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:1\\d|3)\\d{9}|[124-8]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1 $2", ["[14][2-9]|[25-8]"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"],
          CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"],
          CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"],
          CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]],
          CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"],
          CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d|8[0-24-9])\\d{7}|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:83[0-38]|93[0-4])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{3}|45[0-4])\\d{3}|13\\d{4}", [6, 8, 10]]], "0011"],
          CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]],
          CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]],
          DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"],
          DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]],
          DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]],
          DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "767$1", 0, "767"],
          DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"],
          DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"],
          EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"],
          EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
          EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"],
          EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
          ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"],
          ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]],
          ET: ["251", "00", "(?:11|[2-59]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], "0"],
          FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"],
          FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          FK: ["500", "00", "[2-7]\\d{4}", [5]],
          FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]],
          FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"],
          FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"],
          GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], 0, 0, "0(11\\d{6}|6[256]\\d{6}|7[47]\\d{6})", "$1"],
          GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[03])|4(?:[0-5]\\d\\d|69[7-9]|70[059])|(?:5[0-26-9]|6[0-4]|[78][0-49])\\d\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[02]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"],
          GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "473$1", 0, "473"],
          GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"],
          GF: ["594", "00", "(?:[56]94|80\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
          GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "0|([25-9]\\d{5})$", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]],
          GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"],
          GI: ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]],
          GL: ["299", "00", "(?:19|[2-689]\\d)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-689]"]]]],
          GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
          GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]],
          GP: ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]],
          GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]],
          GR: ["30", "00", "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["8"]]]],
          GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
          GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "1|([3-9]\\d{6})$", "671$1", 0, "671"],
          GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]],
          GY: ["592", "001", "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]],
          HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]],
          HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"],
          HT: ["509", "00", "[2-489]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]]],
          HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"],
          ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"],
          IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
          IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"],
          IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([25-8]\\d{5})$", "1624$1", 0, "74576|(?:16|7[56])24"],
          IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"],
          IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]],
          IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
          IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"],
          IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          IT: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]],
          JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([0-24-8]\\d{5})$", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"], ["56\\d{8}"]]],
          JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"],
          JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
          JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"],
          KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
          KG: ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
          KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
          KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"],
          KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]],
          KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "869$1", 0, "869"],
          KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"],
          KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"],
          KW: ["965", "00", "(?:18|[2569]\\d\\d)\\d{5}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[25]"]]]],
          KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "345$1", 0, "345"],
          KZ: ["7", "810", "33622\\d{5}|(?:7\\d|80)\\d{8}", [10], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"],
          LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"],
          LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"],
          LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "758$1", 0, "758"],
          LI: ["423", "00", "90\\d{5}|(?:[2378]|6\\d\\d)\\d{6}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[237-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "0|(1001)"],
          LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"],
          LR: ["231", "00", "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], "0"],
          LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]],
          LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"],
          LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],
          LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]],
          LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"],
          MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[015-7]\\d|2[02-9]|3[0-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0\\d|10|6[1267]|7[0-57]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]],
          MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"],
          MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"],
          ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"],
          MF: ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]],
          MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "0|([24-9]\\d{6})$", "20$1"],
          MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"],
          MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"],
          ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]],
          MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"],
          MN: ["976", "001", "[12]\\d{7,9}|[57-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"],
          MO: ["853", "00", "(?:28|[68]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]],
          MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "670$1", 0, "670"],
          MQ: ["596", "00", "(?:69|80)\\d{7}|(?:59|97)6\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
          MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]],
          MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "1|([34]\\d{6})$", "664$1", 0, "664"],
          MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]],
          MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[2-468]|5\\d)\\d{6}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["5"]]], 0, 0, 0, 0, 0, 0, 0, "020"],
          MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          MW: ["265", "00", "1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"],
          MX: ["52", "0[09]", "(?:1(?:[01467]\\d|[2359][1-9]|8[1-79])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"],
          MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9])|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"],
          MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
          NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
          NC: ["687", "00", "[2-57-9]\\d{5}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]]],
          NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]],
          NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"],
          NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"],
          NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]],
          NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], "0"],
          NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"],
          NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"],
          NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]],
          NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]],
          NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"],
          OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]],
          PA: ["507", "00", "8\\d{9}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]],
          PE: ["51", "19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, 0, " Anexo "],
          PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
          PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          PH: ["63", "00", "1800\\d{7,9}|(?:2|[89]\\d{4})\\d{5}|[2-8]\\d{8}|[28]\\d{7}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"],
          PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"],
          PL: ["48", "00", "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]],
          PM: ["508", "00", "(?:[45]|80\\d\\d)\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
          PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"],
          PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
          PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]],
          PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
          PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"],
          QA: ["974", "00", "[2-7]\\d{7}|(?:2\\d\\d|800)\\d{4}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]]],
          RE: ["262", "00", "9769\\d{5}|(?:26|[68]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, "26[23]|69|[89]"],
          RO: ["40", "00", "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "],
          RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"],
          RU: ["7", "810", "[347-9]\\d{9}", [10], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[3489]"], "8 ($1)", 1]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"],
          RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"],
          SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"],
          SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],
          SC: ["248", "010|0[0-2]", "8000\\d{3}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
          SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"],
          SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-4]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
          SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"],
          SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"],
          SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"],
          SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"],
          SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"],
          SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"],
          SN: ["221", "00", "(?:[378]\\d{4}|93330)\\d{4}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]],
          SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[1-35-9]|9[2-9]"]]], "0"],
          SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]],
          SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
          ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]],
          SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]],
          SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|(5\\d{6})$", "721$1", 0, "721"],
          SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"],
          SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]],
          TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
          TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "1|([2-479]\\d{6})$", "649$1", 0, "649"],
          TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
          TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]],
          TH: ["66", "00[1-9]", "1\\d{9}|[1689]\\d{8}|[1-57]\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
          TJ: ["992", "810", "(?:[02]0|11|[3-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"], 0, 1], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"], 0, 1], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"], 0, 1], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02-57-9]|11"], 0, 1]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
          TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
          TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]],
          TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
          TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]],
          TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]],
          TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"],
          TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-46-8]\\d{6})$", "868$1", 0, "868"],
          TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
          TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"],
          TZ: ["255", "00[056]", "(?:[26-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"],
          UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]", "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"],
          UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"],
          US: ["1", "011", "[2-9]\\d{9}", [10], [["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[02357]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],
          UY: ["598", "0(?:0|1[3-9]\\d)", "4\\d{9}|[249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[24]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "],
          UZ: ["998", "810", "(?:33|55|[679]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
          VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"],
          VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "784$1", 0, "784"],
          VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"],
          VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-578]\\d{6})$", "284$1", 0, "284"],
          VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "340$1", 0, "340"],
          VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"],
          VU: ["678", "00", "[48]8\\d{3}|(?:[23]|[579]\\d\\d)\\d{4}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[579]"]]]],
          WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
          WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
          XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"],
          YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"],
          YT: ["262", "00", "80\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63"],
          ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
          ZM: ["260", "00", "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"],
          ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"]
        },
        nonGeographic: {
          800: ["800", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["[1-9]\\d{7}"]]],
          808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]],
          870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],
          878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]],
          881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]],
          882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["4"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],
          883: ["883", 0, "210\\d{7}|51\\d{7}(?:\\d{3})?", [9, 10, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["510"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["5"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:210|51[013]0\\d)\\d{7}|5100\\d{5}"]]],
          888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]],
          979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]]
        }
      };

      function k(t, e) {
        var n = Array.prototype.slice.call(e);
        return n.push(N), t.apply(this, n);
      }

      function T(t) {
        return T = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, T(t);
      }

      function A(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(n);
          "function" === typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
          }))), r.forEach(function (e) {
            j(t, e, n[e]);
          });
        }

        return t;
      }

      function j(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      function _(t, e) {
        return D(t) || R(t, e) || M();
      }

      function M() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }

      function R(t, e) {
        var n = [],
            r = !0,
            d = !1,
            i = void 0;

        try {
          for (var o, a = t[Symbol.iterator](); !(r = (o = a.next()).done); r = !0) {
            if (n.push(o.value), e && n.length === e) break;
          }
        } catch (u) {
          d = !0, i = u;
        } finally {
          try {
            r || null == a["return"] || a["return"]();
          } finally {
            if (d) throw i;
          }
        }

        return n;
      }

      function D(t) {
        if (Array.isArray(t)) return t;
      }

      function L(t) {
        var e,
            n,
            r,
            d = Array.prototype.slice.call(t),
            i = _(d, 4),
            o = i[0],
            a = i[1],
            u = i[2],
            $ = i[3];

        if ("string" !== typeof o) throw new TypeError("A text for parsing must be a string.");

        if (e = o, a && "string" !== typeof a) {
          if (!F(a)) throw new Error("Invalid second argument: ".concat(a));
          u ? (n = a, r = u) : r = a;
        } else $ ? (n = u, r = $) : (n = void 0, r = u), a && (n = A({
          defaultCountry: a
        }, n));

        return {
          text: e,
          options: n,
          metadata: r
        };
      }

      var F = function F(t) {
        return "object" === T(t);
      },
          B = 2,
          G = 17,
          U = 3,
          V = "0-9０-９٠-٩۰-۹",
          K = "-‐-―−ー－",
          H = "／/",
          W = "．.",
          z = "  ­​⁠　",
          Y = "()（）［］\\[\\]",
          Z = "~⁓∼～",
          q = "".concat(K).concat(H).concat(W).concat(z).concat(Y).concat(Z),
          J = "+＋";

      function X(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      var Q = function t(e) {
        X(this, t), this.name = this.constructor.name, this.message = e, this.stack = new Error(e).stack;
      };

      function tt(t, e) {
        t = t.split("-"), e = e.split("-");

        for (var n = t[0].split("."), r = e[0].split("."), d = 0; d < 3; d++) {
          var i = Number(n[d]),
              o = Number(r[d]);
          if (i > o) return 1;
          if (o > i) return -1;
          if (!isNaN(i) && isNaN(o)) return 1;
          if (isNaN(i) && !isNaN(o)) return -1;
        }

        return t[1] && e[1] ? t[1] > e[1] ? 1 : t[1] < e[1] ? -1 : 0 : !t[1] && e[1] ? 1 : t[1] && !e[1] ? -1 : 0;
      }

      function et(t) {
        return et = "function" === typeof Symbol && "symbol" === _typeof(Symbol.iterator) ? function (t) {
          return _typeof(t);
        } : function (t) {
          return t && "function" === typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
        }, et(t);
      }

      function nt(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function rt(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function dt(t, e, n) {
        return e && rt(t.prototype, e), n && rt(t, n), t;
      }

      Q.prototype = Object.create(Error.prototype), Q.prototype.constructor = Q;

      var it = "1.2.0",
          ot = "1.7.35",
          at = " ext. ",
          ut = /^\d+$/,
          $t = function () {
        function t(e) {
          nt(this, t), ht(e), this.metadata = e, bt.call(this, e);
        }

        return dt(t, [{
          key: "getCountries",
          value: function value() {
            return Object.keys(this.metadata.countries).filter(function (t) {
              return "001" !== t;
            });
          }
        }, {
          key: "getCountryMetadata",
          value: function value(t) {
            return this.metadata.countries[t];
          }
        }, {
          key: "nonGeographic",
          value: function value() {
            if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
          }
        }, {
          key: "hasCountry",
          value: function value(t) {
            return void 0 !== this.getCountryMetadata(t);
          }
        }, {
          key: "hasCallingCode",
          value: function value(t) {
            if (this.getCountryCodesForCallingCode(t)) return !0;

            if (this.nonGeographic()) {
              if (this.nonGeographic()[t]) return !0;
            } else {
              var e = this.countryCallingCodes()[t];
              if (e && 1 === e.length && "001" === e[0]) return !0;
            }
          }
        }, {
          key: "isNonGeographicCallingCode",
          value: function value(t) {
            return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
          }
        }, {
          key: "country",
          value: function value(t) {
            return this.selectNumberingPlan(t);
          }
        }, {
          key: "selectNumberingPlan",
          value: function value(t, e) {
            if (t && ut.test(t) && (e = t, t = null), t && "001" !== t) {
              if (!this.hasCountry(t)) throw new Error("Unknown country: ".concat(t));
              this.numberingPlan = new ct(this.getCountryMetadata(t), this);
            } else if (e) {
              if (!this.hasCallingCode(e)) throw new Error("Unknown calling code: ".concat(e));
              this.numberingPlan = new ct(this.getNumberingPlanMetadata(e), this);
            } else this.numberingPlan = void 0;

            return this;
          }
        }, {
          key: "getCountryCodesForCallingCode",
          value: function value(t) {
            var e = this.countryCallingCodes()[t];

            if (e) {
              if (1 === e.length && 3 === e[0].length) return;
              return e;
            }
          }
        }, {
          key: "getCountryCodeForCallingCode",
          value: function value(t) {
            var e = this.getCountryCodesForCallingCode(t);
            if (e) return e[0];
          }
        }, {
          key: "getNumberingPlanMetadata",
          value: function value(t) {
            var e = this.getCountryCodeForCallingCode(t);
            if (e) return this.getCountryMetadata(e);

            if (this.nonGeographic()) {
              var n = this.nonGeographic()[t];
              if (n) return n;
            } else {
              var r = this.countryCallingCodes()[t];
              if (r && 1 === r.length && "001" === r[0]) return this.metadata.countries["001"];
            }
          }
        }, {
          key: "countryCallingCode",
          value: function value() {
            return this.numberingPlan.callingCode();
          }
        }, {
          key: "IDDPrefix",
          value: function value() {
            return this.numberingPlan.IDDPrefix();
          }
        }, {
          key: "defaultIDDPrefix",
          value: function value() {
            return this.numberingPlan.defaultIDDPrefix();
          }
        }, {
          key: "nationalNumberPattern",
          value: function value() {
            return this.numberingPlan.nationalNumberPattern();
          }
        }, {
          key: "possibleLengths",
          value: function value() {
            return this.numberingPlan.possibleLengths();
          }
        }, {
          key: "formats",
          value: function value() {
            return this.numberingPlan.formats();
          }
        }, {
          key: "nationalPrefixForParsing",
          value: function value() {
            return this.numberingPlan.nationalPrefixForParsing();
          }
        }, {
          key: "nationalPrefixTransformRule",
          value: function value() {
            return this.numberingPlan.nationalPrefixTransformRule();
          }
        }, {
          key: "leadingDigits",
          value: function value() {
            return this.numberingPlan.leadingDigits();
          }
        }, {
          key: "hasTypes",
          value: function value() {
            return this.numberingPlan.hasTypes();
          }
        }, {
          key: "type",
          value: function value(t) {
            return this.numberingPlan.type(t);
          }
        }, {
          key: "ext",
          value: function value() {
            return this.numberingPlan.ext();
          }
        }, {
          key: "countryCallingCodes",
          value: function value() {
            return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
          }
        }, {
          key: "chooseCountryByCountryCallingCode",
          value: function value(t) {
            return this.selectNumberingPlan(t);
          }
        }, {
          key: "hasSelectedNumberingPlan",
          value: function value() {
            return void 0 !== this.numberingPlan;
          }
        }]), t;
      }(),
          ct = function () {
        function t(e, n) {
          nt(this, t), this.globalMetadataObject = n, this.metadata = e, bt.call(this, n.metadata);
        }

        return dt(t, [{
          key: "callingCode",
          value: function value() {
            return this.metadata[0];
          }
        }, {
          key: "getDefaultCountryMetadataForRegion",
          value: function value() {
            return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
          }
        }, {
          key: "IDDPrefix",
          value: function value() {
            if (!this.v1 && !this.v2) return this.metadata[1];
          }
        }, {
          key: "defaultIDDPrefix",
          value: function value() {
            if (!this.v1 && !this.v2) return this.metadata[12];
          }
        }, {
          key: "nationalNumberPattern",
          value: function value() {
            return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
          }
        }, {
          key: "possibleLengths",
          value: function value() {
            if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
          }
        }, {
          key: "_getFormats",
          value: function value(t) {
            return t[this.v1 ? 2 : this.v2 ? 3 : 4];
          }
        }, {
          key: "formats",
          value: function value() {
            var t = this,
                e = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
            return e.map(function (e) {
              return new st(e, t);
            });
          }
        }, {
          key: "nationalPrefix",
          value: function value() {
            return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
          }
        }, {
          key: "_getNationalPrefixFormattingRule",
          value: function value(t) {
            return t[this.v1 ? 4 : this.v2 ? 5 : 6];
          }
        }, {
          key: "nationalPrefixFormattingRule",
          value: function value() {
            return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
          }
        }, {
          key: "_nationalPrefixForParsing",
          value: function value() {
            return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
          }
        }, {
          key: "nationalPrefixForParsing",
          value: function value() {
            return this._nationalPrefixForParsing() || this.nationalPrefix();
          }
        }, {
          key: "nationalPrefixTransformRule",
          value: function value() {
            return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
          }
        }, {
          key: "_getNationalPrefixIsOptionalWhenFormatting",
          value: function value() {
            return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
          }
        }, {
          key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
          value: function value() {
            return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
          }
        }, {
          key: "leadingDigits",
          value: function value() {
            return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
          }
        }, {
          key: "types",
          value: function value() {
            return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
          }
        }, {
          key: "hasTypes",
          value: function value() {
            return (!this.types() || 0 !== this.types().length) && !!this.types();
          }
        }, {
          key: "type",
          value: function value(t) {
            if (this.hasTypes() && pt(this.types(), t)) return new ft(pt(this.types(), t), this);
          }
        }, {
          key: "ext",
          value: function value() {
            return this.v1 || this.v2 ? at : this.metadata[13] || at;
          }
        }]), t;
      }(),
          st = function () {
        function t(e, n) {
          nt(this, t), this._format = e, this.metadata = n;
        }

        return dt(t, [{
          key: "pattern",
          value: function value() {
            return this._format[0];
          }
        }, {
          key: "format",
          value: function value() {
            return this._format[1];
          }
        }, {
          key: "leadingDigitsPatterns",
          value: function value() {
            return this._format[2] || [];
          }
        }, {
          key: "nationalPrefixFormattingRule",
          value: function value() {
            return this._format[3] || this.metadata.nationalPrefixFormattingRule();
          }
        }, {
          key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
          value: function value() {
            return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
          }
        }, {
          key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
          value: function value() {
            return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
          }
        }, {
          key: "usesNationalPrefix",
          value: function value() {
            return !(!this.nationalPrefixFormattingRule() || lt.test(this.nationalPrefixFormattingRule()));
          }
        }, {
          key: "internationalFormat",
          value: function value() {
            return this._format[5] || this.format();
          }
        }]), t;
      }(),
          lt = /^\(?\$1\)?$/,
          ft = function () {
        function t(e, n) {
          nt(this, t), this.type = e, this.metadata = n;
        }

        return dt(t, [{
          key: "pattern",
          value: function value() {
            return this.metadata.v1 ? this.type : this.type[0];
          }
        }, {
          key: "possibleLengths",
          value: function value() {
            if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
          }
        }]), t;
      }();

      function pt(t, e) {
        switch (e) {
          case "FIXED_LINE":
            return t[0];

          case "MOBILE":
            return t[1];

          case "TOLL_FREE":
            return t[2];

          case "PREMIUM_RATE":
            return t[3];

          case "PERSONAL_NUMBER":
            return t[4];

          case "VOICEMAIL":
            return t[5];

          case "UAN":
            return t[6];

          case "PAGER":
            return t[7];

          case "VOIP":
            return t[8];

          case "SHARED_COST":
            return t[9];
        }
      }

      function ht(t) {
        if (!t) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
        if (!vt(t) || !vt(t.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(vt(t) ? "an object of shape: { " + Object.keys(t).join(", ") + " }" : "a " + yt(t) + ": " + t, "."));
      }

      var vt = function vt(t) {
        return "object" === et(t);
      },
          yt = function yt(t) {
        return et(t);
      };

      function gt(t, e) {
        if (e = new $t(e), e.hasCountry(t)) return e.country(t).countryCallingCode();
        throw new Error("Unknown country: ".concat(t));
      }

      function mt(t, e) {
        return void 0 !== e.countries[t];
      }

      function bt(t) {
        var e = t.version;
        "number" === typeof e ? (this.v1 = 1 === e, this.v2 = 2 === e, this.v3 = 3 === e, this.v4 = 4 === e) : e ? -1 === tt(e, it) ? this.v2 = !0 : -1 === tt(e, ot) ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
      }

      var Ct = ";ext=",
          xt = function xt(t) {
        return "([".concat(V, "]{1,").concat(t, "})");
      };

      function Ot(t) {
        var e = "20",
            n = "15",
            r = "9",
            d = "6",
            i = "[  \\t,]*",
            o = "[:\\.．]?[  \\t,-]*",
            a = "#?",
            u = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)",
            $ = "(?:[xｘ#＃~～]|int|ｉｎｔ)",
            c = "[- ]+",
            s = "[  \\t]*",
            l = "(?:,{2}|;)",
            f = Ct + xt(e),
            p = i + u + o + xt(e) + a,
            h = i + $ + o + xt(r) + a,
            v = c + xt(d) + "#",
            y = s + l + o + xt(n) + a,
            g = s + "(?:,)+" + o + xt(r) + a;
        return f + "|" + p + "|" + h + "|" + v + "|" + y + "|" + g;
      }

      var wt = "[" + V + "]{" + B + "}",
          St = "[" + J + "]{0,1}(?:[" + q + "]*[" + V + "]){3,}[" + q + V + "]*",
          Et = St + "(?:" + Ot() + ")?",
          Pt = new RegExp("^" + wt + "$|^" + Et + "$", "i");

      function It(t) {
        return t.length >= B && Pt.test(t);
      }

      var Nt = new RegExp("(?:" + Ot() + ")$", "i");

      function kt(t) {
        var e = t.search(Nt);
        if (e < 0) return {};
        var n = t.slice(0, e),
            r = t.match(Nt),
            d = 1;

        while (d < r.length) {
          if (r[d]) return {
            number: n,
            ext: r[d]
          };
          d++;
        }
      }

      var Tt = {
        0: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        "０": "0",
        "１": "1",
        "２": "2",
        "３": "3",
        "４": "4",
        "５": "5",
        "６": "6",
        "７": "7",
        "８": "8",
        "９": "9",
        "٠": "0",
        "١": "1",
        "٢": "2",
        "٣": "3",
        "٤": "4",
        "٥": "5",
        "٦": "6",
        "٧": "7",
        "٨": "8",
        "٩": "9",
        "۰": "0",
        "۱": "1",
        "۲": "2",
        "۳": "3",
        "۴": "4",
        "۵": "5",
        "۶": "6",
        "۷": "7",
        "۸": "8",
        "۹": "9"
      };

      function At(t) {
        return Tt[t];
      }

      function jt(t) {
        var e = "",
            n = t.split(""),
            r = Array.isArray(n),
            d = 0;

        for (n = r ? n : n[Symbol.iterator]();;) {
          var i;

          if (r) {
            if (d >= n.length) break;
            i = n[d++];
          } else {
            if (d = n.next(), d.done) break;
            i = d.value;
          }

          var o = i;
          e += _t(o, e) || "";
        }

        return e;
      }

      function _t(t, e) {
        if ("+" === t) {
          if (e) return;
          return "+";
        }

        return At(t);
      }

      function Mt(t, e) {
        var n = t.slice(),
            r = e,
            d = Array.isArray(r),
            i = 0;

        for (r = d ? r : r[Symbol.iterator]();;) {
          var o;

          if (d) {
            if (i >= r.length) break;
            o = r[i++];
          } else {
            if (i = r.next(), i.done) break;
            o = i.value;
          }

          var a = o;
          t.indexOf(a) < 0 && n.push(a);
        }

        return n.sort(function (t, e) {
          return t - e;
        });
      }

      function Rt(t, e) {
        return Dt(t, void 0, e);
      }

      function Dt(t, e, n) {
        var r = n.type(e),
            d = r && r.possibleLengths() || n.possibleLengths();
        if (!d) return "IS_POSSIBLE";

        if ("FIXED_LINE_OR_MOBILE" === e) {
          if (!n.type("FIXED_LINE")) return Dt(t, "MOBILE", n);
          var i = n.type("MOBILE");
          i && (d = Mt(d, i.possibleLengths()));
        } else if (e && !r) return "INVALID_LENGTH";

        var o = t.length,
            a = d[0];
        return a === o ? "IS_POSSIBLE" : a > o ? "TOO_SHORT" : d[d.length - 1] < o ? "TOO_LONG" : d.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
      }

      function Lt(t, e, n) {
        if (void 0 === e && (e = {}), n = new $t(n), e.v2) {
          if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
          n.selectNumberingPlan(t.countryCallingCode);
        } else {
          if (!t.phone) return !1;

          if (t.country) {
            if (!n.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
            n.country(t.country);
          } else {
            if (!t.countryCallingCode) throw new Error("Invalid phone number object passed");
            n.selectNumberingPlan(t.countryCallingCode);
          }
        }

        if (n.possibleLengths()) return Ft(t.phone || t.nationalNumber, n);
        if (t.countryCallingCode && n.isNonGeographicCallingCode(t.countryCallingCode)) return !0;
        throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
      }

      function Ft(t, e) {
        switch (Rt(t, e)) {
          case "IS_POSSIBLE":
            return !0;

          default:
            return !1;
        }
      }

      function Bt(t, e) {
        return Vt(t) || Ut(t, e) || Gt();
      }

      function Gt() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }

      function Ut(t, e) {
        var n = [],
            r = !0,
            d = !1,
            i = void 0;

        try {
          for (var o, a = t[Symbol.iterator](); !(r = (o = a.next()).done); r = !0) {
            if (n.push(o.value), e && n.length === e) break;
          }
        } catch (u) {
          d = !0, i = u;
        } finally {
          try {
            r || null == a["return"] || a["return"]();
          } finally {
            if (d) throw i;
          }
        }

        return n;
      }

      function Vt(t) {
        if (Array.isArray(t)) return t;
      }

      function Kt(t) {
        var e, n;
        t = t.replace(/^tel:/, "tel=");
        var r = t.split(";"),
            d = Array.isArray(r),
            i = 0;

        for (r = d ? r : r[Symbol.iterator]();;) {
          var o;

          if (d) {
            if (i >= r.length) break;
            o = r[i++];
          } else {
            if (i = r.next(), i.done) break;
            o = i.value;
          }

          var a = o,
              u = a.split("="),
              $ = Bt(u, 2),
              c = $[0],
              s = $[1];

          switch (c) {
            case "tel":
              e = s;
              break;

            case "ext":
              n = s;
              break;

            case "phone-context":
              "+" === s[0] && (e = s + e);
              break;
          }
        }

        if (!It(e)) return {};
        var l = {
          number: e
        };
        return n && (l.ext = n), l;
      }

      function Ht(t) {
        var e = t.number,
            n = t.ext;
        if (!e) return "";
        if ("+" !== e[0]) throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
        return "tel:".concat(e).concat(n ? ";ext=" + n : "");
      }

      function Wt(t, e) {
        return t = t || "", new RegExp("^(?:" + e + ")$").test(t);
      }

      var zt = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];

      function Yt(t, e, n) {
        if (e = e || {}, t.country) {
          n = new $t(n), n.selectNumberingPlan(t.country, t.countryCallingCode);
          var r = e.v2 ? t.nationalNumber : t.phone;

          if (Wt(r, n.nationalNumberPattern())) {
            if (Zt(r, "FIXED_LINE", n)) return n.type("MOBILE") && "" === n.type("MOBILE").pattern() ? "FIXED_LINE_OR_MOBILE" : n.type("MOBILE") ? Zt(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE" : "FIXED_LINE_OR_MOBILE";

            for (var d = 0, i = zt; d < i.length; d++) {
              var o = i[d];
              if (Zt(r, o, n)) return o;
            }
          }
        }
      }

      function Zt(t, e, n) {
        return e = n.type(e), !(!e || !e.pattern()) && !(e.possibleLengths() && e.possibleLengths().indexOf(t.length) < 0) && Wt(t, e.pattern());
      }

      function qt(t, e, n) {
        if (e = e || {}, n = new $t(n), !t.country) return !1;
        if (n.selectNumberingPlan(t.country, t.countryCallingCode), n.hasTypes()) return void 0 !== Yt(t, e, n.metadata);
        var r = e.v2 ? t.nationalNumber : t.phone;
        return Wt(r, n.nationalNumberPattern());
      }

      function Jt(t) {
        return t.replace(new RegExp("[".concat(q, "]+"), "g"), " ").trim();
      }

      var Xt = /(\$\d)/;

      function Qt(t, e, n) {
        var r = n.useInternationalFormat,
            d = n.withNationalPrefix,
            i = (n.carrierCode, n.metadata, t.replace(new RegExp(e.pattern()), r ? e.internationalFormat() : d && e.nationalPrefixFormattingRule() ? e.format().replace(Xt, e.nationalPrefixFormattingRule()) : e.format()));
        return r ? Jt(i) : i;
      }

      var te = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;

      function ee(t, e, n) {
        var r = new $t(n);
        return r.selectNumberingPlan(t, e), te.test(r.IDDPrefix()) ? r.IDDPrefix() : r.defaultIDDPrefix();
      }

      function ne(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(n);
          "function" === typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
          }))), r.forEach(function (e) {
            re(t, e, n[e]);
          });
        }

        return t;
      }

      function re(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      var de = {
        formatExtension: function formatExtension(t, e, n) {
          return "".concat(t).concat(n.ext()).concat(e);
        }
      };

      function ie(t, e, n, r) {
        if (n = n ? ne({}, de, n) : de, r = new $t(r), t.country && "001" !== t.country) {
          if (!r.hasCountry(t.country)) throw new Error("Unknown country: ".concat(t.country));
          r.country(t.country);
        } else {
          if (!t.countryCallingCode) return t.phone || "";
          r.selectNumberingPlan(t.countryCallingCode);
        }

        var d,
            i = r.countryCallingCode(),
            o = n.v2 ? t.nationalNumber : t.phone;

        switch (e) {
          case "NATIONAL":
            return o ? (d = oe(o, t.carrierCode, "NATIONAL", r, n), ue(d, t.ext, r, n.formatExtension)) : "";

          case "INTERNATIONAL":
            return o ? (d = oe(o, null, "INTERNATIONAL", r, n), d = "+".concat(i, " ").concat(d), ue(d, t.ext, r, n.formatExtension)) : "+".concat(i);

          case "E.164":
            return "+".concat(i).concat(o);

          case "RFC3966":
            return Ht({
              number: "+".concat(i).concat(o),
              ext: t.ext
            });

          case "IDD":
            if (!n.fromCountry) return;
            var a = $e(o, t.carrierCode, i, n.fromCountry, r);
            return ue(a, t.ext, r, n.formatExtension);

          default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
        }
      }

      function oe(t, e, n, r, d) {
        var i = ae(r.formats(), t);
        return i ? Qt(t, i, {
          useInternationalFormat: "INTERNATIONAL" === n,
          withNationalPrefix: !i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !d || !1 !== d.nationalPrefix,
          carrierCode: e,
          metadata: r
        }) : t;
      }

      function ae(t, e) {
        var n = t,
            r = Array.isArray(n),
            d = 0;

        for (n = r ? n : n[Symbol.iterator]();;) {
          var i;

          if (r) {
            if (d >= n.length) break;
            i = n[d++];
          } else {
            if (d = n.next(), d.done) break;
            i = d.value;
          }

          var o = i;

          if (o.leadingDigitsPatterns().length > 0) {
            var a = o.leadingDigitsPatterns()[o.leadingDigitsPatterns().length - 1];
            if (0 !== e.search(a)) continue;
          }

          if (Wt(e, o.pattern())) return o;
        }
      }

      function ue(t, e, n, r) {
        return e ? r(t, e, n) : t;
      }

      function $e(t, e, n, r, d) {
        var i = gt(r, d.metadata);

        if (i === n) {
          var o = oe(t, e, "NATIONAL", d);
          return "1" === n ? n + " " + o : o;
        }

        var a = ee(r, void 0, d.metadata);
        if (a) return "".concat(a, " ").concat(n, " ").concat(oe(t, null, "INTERNATIONAL", d));
      }

      function ce(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(n);
          "function" === typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
          }))), r.forEach(function (e) {
            se(t, e, n[e]);
          });
        }

        return t;
      }

      function se(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      function le(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }

      function fe(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
      }

      function pe(t, e, n) {
        return e && fe(t.prototype, e), n && fe(t, n), t;
      }

      var he = !1,
          ve = function () {
        function t(e, n, r) {
          if (le(this, t), !e) throw new TypeError("`country` or `countryCallingCode` not passed");
          if (!n) throw new TypeError("`nationalNumber` not passed");
          var d = new $t(r);
          ye(e) ? (this.country = e, d.country(e), e = d.countryCallingCode()) : he && d.isNonGeographicCallingCode(e) && (this.country = "001"), this.countryCallingCode = e, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.metadata = r;
        }

        return pe(t, [{
          key: "isPossible",
          value: function value() {
            return Lt(this, {
              v2: !0
            }, this.metadata);
          }
        }, {
          key: "isValid",
          value: function value() {
            return qt(this, {
              v2: !0
            }, this.metadata);
          }
        }, {
          key: "isNonGeographic",
          value: function value() {
            var t = new $t(this.metadata);
            return t.isNonGeographicCallingCode(this.countryCallingCode);
          }
        }, {
          key: "isEqual",
          value: function value(t) {
            return this.number === t.number && this.ext === t.ext;
          }
        }, {
          key: "getType",
          value: function value() {
            return Yt(this, {
              v2: !0
            }, this.metadata);
          }
        }, {
          key: "format",
          value: function value(t, e) {
            return ie(this, t, e ? ce({}, e, {
              v2: !0
            }) : {
              v2: !0
            }, this.metadata);
          }
        }, {
          key: "formatNational",
          value: function value(t) {
            return this.format("NATIONAL", t);
          }
        }, {
          key: "formatInternational",
          value: function value(t) {
            return this.format("INTERNATIONAL", t);
          }
        }, {
          key: "getURI",
          value: function value(t) {
            return this.format("RFC3966", t);
          }
        }]), t;
      }(),
          ye = function ye(t) {
        return /^[A-Z]{2}$/.test(t);
      },
          ge = new RegExp("([" + V + "])");

      function me(t, e, n, r) {
        if (e) {
          var d = new $t(r);
          d.selectNumberingPlan(e, n);
          var i = new RegExp(d.IDDPrefix());

          if (0 === t.search(i)) {
            t = t.slice(t.match(i)[0].length);
            var o = t.match(ge);
            if (!(o && null != o[1] && o[1].length > 0 && "0" === o[1])) return t;
          }
        }
      }

      function be(t, e) {
        if (t && e.numberingPlan.nationalPrefixForParsing()) {
          var n = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"),
              r = n.exec(t);

          if (r) {
            var d,
                i,
                o,
                a = r.length - 1,
                u = a > 0 && r[a];
            if (e.nationalPrefixTransformRule() && u) d = t.replace(n, e.nationalPrefixTransformRule()), a > 1 && (i = r[1]);else {
              var $ = r[0];
              d = t.slice($.length), u && (i = r[1]);
            }

            if (u) {
              var c = t.indexOf(r[1]),
                  s = t.slice(0, c);
              s === e.numberingPlan.nationalPrefix() && (o = e.numberingPlan.nationalPrefix());
            } else o = r[0];

            return {
              nationalNumber: d,
              nationalPrefix: o,
              carrierCode: i
            };
          }
        }

        return {
          nationalNumber: t
        };
      }

      function Ce(t, e) {
        var n = be(t, e),
            r = n.nationalNumber,
            d = n.carrierCode;
        if (!xe(t, r, e)) return {
          nationalNumber: t
        };
        if (t.length !== r.length + (d ? d.length : 0) && e.possibleLengths()) switch (Rt(r, e)) {
          case "TOO_SHORT":
          case "INVALID_LENGTH":
            return {
              nationalNumber: t
            };
        }
        return {
          nationalNumber: r,
          carrierCode: d
        };
      }

      function xe(t, e, n) {
        return !(Wt(t, n.nationalNumberPattern()) && !Wt(e, n.nationalNumberPattern()));
      }

      function Oe(t, e, n, r) {
        var d = e ? gt(e, r) : n;

        if (0 === t.indexOf(d)) {
          r = new $t(r), r.selectNumberingPlan(e, n);
          var i = t.slice(d.length),
              o = Ce(i, r),
              a = o.nationalNumber,
              u = Ce(t, r),
              $ = u.nationalNumber;
          if (!Wt($, r.nationalNumberPattern()) && Wt(a, r.nationalNumberPattern()) || "TOO_LONG" === Rt($, r)) return {
            countryCallingCode: d,
            number: i
          };
        }

        return {
          number: t
        };
      }

      function we(t, e, n, r) {
        if (!t) return {};

        if ("+" !== t[0]) {
          var d = me(t, e, n, r);

          if (!d || d === t) {
            if (e || n) {
              var i = Oe(t, e, n, r),
                  o = i.countryCallingCode,
                  a = i.number;
              if (o) return {
                countryCallingCode: o,
                number: a
              };
            }

            return {
              number: t
            };
          }

          t = "+" + d;
        }

        if ("0" === t[1]) return {};
        r = new $t(r);
        var u = 2;

        while (u - 1 <= U && u <= t.length) {
          var $ = t.slice(1, u);
          if (r.hasCallingCode($)) return r.selectNumberingPlan($), {
            countryCallingCode: $,
            number: t.slice(u)
          };
          u++;
        }

        return {};
      }

      var Se = !1;

      function Ee(t, e, n) {
        if (Se && n.isNonGeographicCallingCode(t)) return "001";
        var r = n.getCountryCodesForCallingCode(t);
        return r ? 1 === r.length ? r[0] : Pe(r, e, n.metadata) : void 0;
      }

      function Pe(t, e, n) {
        n = new $t(n);
        var r = t,
            d = Array.isArray(r),
            i = 0;

        for (r = d ? r : r[Symbol.iterator]();;) {
          var o;

          if (d) {
            if (i >= r.length) break;
            o = r[i++];
          } else {
            if (i = r.next(), i.done) break;
            o = i.value;
          }

          var a = o;

          if (n.country(a), n.leadingDigits()) {
            if (e && 0 === e.search(n.leadingDigits())) return a;
          } else if (Yt({
            phone: e,
            country: a
          }, void 0, n.metadata)) return a;
        }
      }

      var Ie = 250,
          Ne = new RegExp("[" + J + V + "]"),
          ke = new RegExp("[^" + V + "#]+$"),
          Te = !1;

      function Ae(t, e, n) {
        if (e = e || {}, n = new $t(n), e.defaultCountry && !n.hasCountry(e.defaultCountry)) {
          if (e.v2) throw new Q("INVALID_COUNTRY");
          throw new Error("Unknown country: ".concat(e.defaultCountry));
        }

        var r = _e(t, e.v2, e.extract),
            d = r.number,
            i = r.ext;

        if (!d) {
          if (e.v2) throw new Q("NOT_A_NUMBER");
          return {};
        }

        var o = Re(d, e.defaultCountry, e.defaultCallingCode, n),
            a = o.country,
            u = o.nationalNumber,
            $ = o.countryCallingCode,
            c = o.carrierCode;

        if (!n.hasSelectedNumberingPlan()) {
          if (e.v2) throw new Q("INVALID_COUNTRY");
          return {};
        }

        if (!u || u.length < B) {
          if (e.v2) throw new Q("TOO_SHORT");
          return {};
        }

        if (u.length > G) {
          if (e.v2) throw new Q("TOO_LONG");
          return {};
        }

        if (e.v2) {
          var s = new ve($, u, n.metadata);
          return a && (s.country = a), c && (s.carrierCode = c), i && (s.ext = i), s;
        }

        var l = !!(e.extended ? n.hasSelectedNumberingPlan() : a) && Wt(u, n.nationalNumberPattern());
        return e.extended ? {
          country: a,
          countryCallingCode: $,
          carrierCode: c,
          valid: l,
          possible: !!l || !(!0 !== e.extended || !n.possibleLengths() || !Ft(u, n)),
          phone: u,
          ext: i
        } : l ? Me(a, u, i) : {};
      }

      function je(t, e, n) {
        if (t) if (t.length > Ie) {
          if (n) throw new Q("TOO_LONG");
        } else {
          if (!1 === e) return t;
          var r = t.search(Ne);
          if (!(r < 0)) return t.slice(r).replace(ke, "");
        }
      }

      function _e(t, e, n) {
        if (t && 0 === t.indexOf("tel:")) return Kt(t);
        var r = je(t, n, e);
        if (!r || !It(r)) return {};
        var d = kt(r);
        return d.ext ? d : {
          number: r
        };
      }

      function Me(t, e, n) {
        var r = {
          country: t,
          phone: e
        };
        return n && (r.ext = n), r;
      }

      function Re(t, e, n, r) {
        var d,
            i = we(jt(t), e, n, r.metadata),
            o = i.countryCallingCode,
            a = i.number;
        if (o) r.selectNumberingPlan(o);else {
          if (!a || !e && !n) return {};
          r.selectNumberingPlan(e, n), e ? d = e : Te && r.isNonGeographicCallingCode(n) && (d = "001"), o = n || gt(e, r.metadata);
        }
        if (!a) return {
          countryCallingCode: o
        };
        var u = Ce(jt(a), r),
            $ = u.nationalNumber,
            c = u.carrierCode,
            s = Ee(o, $, r);
        return s && (d = s, "001" === s || r.country(d)), {
          country: d,
          countryCallingCode: o,
          nationalNumber: $,
          carrierCode: c
        };
      }

      function De(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(n);
          "function" === typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
          }))), r.forEach(function (e) {
            Le(t, e, n[e]);
          });
        }

        return t;
      }

      function Le(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      function Fe(t, e, n) {
        return Ae(t, De({}, e, {
          v2: !0
        }), n);
      }

      function Be(t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(n);
          "function" === typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (t) {
            return Object.getOwnPropertyDescriptor(n, t).enumerable;
          }))), r.forEach(function (e) {
            Ge(t, e, n[e]);
          });
        }

        return t;
      }

      function Ge(t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }

      function Ue(t, e, n) {
        e && e.defaultCountry && !mt(e.defaultCountry, n) && (e = Be({}, e, {
          defaultCountry: void 0
        }));

        try {
          return Fe(t, e, n);
        } catch (r) {
          if (!(r instanceof Q)) throw r;
        }
      }

      function Ve() {
        var t = L(arguments),
            e = t.text,
            n = t.options,
            r = t.metadata;
        return Ue(e, n, r);
      }

      function Ke() {
        return k(Ve, arguments);
      }

      function He(t, e) {
        var n = e || [],
            r = t.parentNode;
        return r ? He(r, n.concat(r)) : n;
      }

      var We = {
        bind: function bind(t, e, n) {
          if ("function" !== typeof e.value) {
            var r = n.context.name,
                d = "[Vue-click-outside:] provided expression ".concat(e.expression, " is not a function, but has to be");
            r && (d += "Found in component ".concat(r)), console.warn(d);
          }

          var i = e.modifiers.bubble,
              o = function o(n) {
            var r = n.path || !!n.composedPath && n.composedPath() || He(n.target);
            (i || r.length && !t.contains(r[0]) && t !== r[0]) && e.value(n);
          };

          t.__vueClickOutside__ = o, document.addEventListener("click", o);
        },
        unbind: function unbind(t) {
          document.removeEventListener("click", t.__vueClickOutside__), t.__vueClickOutside__ = null;
        }
      },
          ze = ["metadata"];

      function Ye(t) {
        var e = x.options[t];
        return "undefined" === typeof e ? x.options[t] : e;
      }

      var Ze = {
        name: "VueTelInput",
        directives: {
          clickOutside: We
        },
        props: {
          value: {
            type: String,
            default: ""
          },
          allCountries: {
            type: Array,
            default: function _default() {
              return Ye("allCountries");
            }
          },
          autoFormat: {
            type: Boolean,
            default: function _default() {
              return Ye("autoFormat");
            }
          },
          customValidate: {
            type: [Boolean, RegExp],
            default: function _default() {
              return Ye("customValidate");
            }
          },
          defaultCountry: {
            type: [String, Number],
            default: function _default() {
              return Ye("defaultCountry");
            }
          },
          disabled: {
            type: Boolean,
            default: function _default() {
              return Ye("disabled");
            }
          },
          autoDefaultCountry: {
            type: Boolean,
            default: function _default() {
              return Ye("autoDefaultCountry");
            }
          },
          dropdownOptions: {
            type: Object,
            default: function _default() {
              return Ye("dropdownOptions");
            }
          },
          ignoredCountries: {
            type: Array,
            default: function _default() {
              return Ye("ignoredCountries");
            }
          },
          inputOptions: {
            type: Object,
            default: function _default() {
              return Ye("inputOptions");
            }
          },
          invalidMsg: {
            type: String,
            default: function _default() {
              return Ye("invalidMsg");
            }
          },
          mode: {
            type: String,
            default: function _default() {
              return Ye("mode");
            }
          },
          onlyCountries: {
            type: Array,
            default: function _default() {
              return Ye("onlyCountries");
            }
          },
          preferredCountries: {
            type: Array,
            default: function _default() {
              return Ye("preferredCountries");
            }
          },
          validCharactersOnly: {
            type: Boolean,
            default: function _default() {
              return Ye("validCharactersOnly");
            }
          },
          styleClasses: {
            type: [String, Array, Object],
            default: function _default() {
              return Ye("styleClasses");
            }
          }
        },
        data: function data() {
          return {
            phone: "",
            activeCountryCode: "",
            open: !1,
            finishMounted: !1,
            selectedIndex: null,
            typeToFindInput: "",
            typeToFindTimer: null,
            dropdownOpenDirection: "below",
            parsedPlaceholder: this.inputOptions.placeholder,
            searchQuery: ""
          };
        },
        computed: {
          activeCountry: function activeCountry() {
            return this.findCountry(this.activeCountryCode);
          },
          parsedMode: function parsedMode() {
            return "auto" === this.mode ? this.phone && "+" === this.phone[0] ? "international" : "national" : ["international", "national"].includes(this.mode) ? this.mode : (console.error('Invalid value of prop "mode"'), "international");
          },
          filteredCountries: function filteredCountries() {
            var t = this;
            return this.onlyCountries.length ? this.allCountries.filter(function (e) {
              var n = e.iso2;
              return t.onlyCountries.some(function (t) {
                return t.toUpperCase() === n;
              });
            }) : this.ignoredCountries.length ? this.allCountries.filter(function (e) {
              var n = e.iso2;
              return !t.ignoredCountries.includes(n.toUpperCase()) && !t.ignoredCountries.includes(n.toLowerCase());
            }) : this.allCountries;
          },
          sortedCountries: function sortedCountries() {
            var t = this,
                e = this.getCountries(this.preferredCountries).map(function (t) {
              return a(a({}, t), {}, {
                preferred: !0
              });
            }),
                n = [].concat(I(e), I(this.filteredCountries));
            return this.dropdownOptions.showSearchBox ? n.filter(function (e) {
              return new RegExp(t.searchQuery, "i").test(e.name) || new RegExp(t.searchQuery, "i").test(e.iso2) || new RegExp(t.searchQuery, "i").test(e.dialCode);
            }) : n;
          },
          phoneObject: function phoneObject() {
            var t, e, n, r, d;
            if (!this.finishMounted) return {};
            d = "+" === (null === (t = this.phone) || void 0 === t ? void 0 : t[0]) ? Ke(this.phone) || {} : Ke(this.phone, this.activeCountryCode) || {}, this.inputOptions.showDialCode && "+" !== (null === (e = this.phone) || void 0 === e ? void 0 : e[0]) && Object.assign(d, {
              country: "--"
            });
            var i,
                o,
                a = d,
                u = (a.metadata, $(a, ze)),
                c = null === (n = (r = d).isValid) || void 0 === n ? void 0 : n.call(r),
                s = this.phone;
            c && (s = null === (i = (o = d).format) || void 0 === i ? void 0 : i.call(o, this.parsedMode.toUpperCase()));
            return d.country && (this.ignoredCountries.length || this.onlyCountries.length) && (this.findCountry(d.country) || (c = !1, Object.assign(d, {
              country: "--"
            }))), Object.assign(u, {
              countryCode: d.country,
              valid: c,
              country: this.activeCountry,
              formatted: s
            }), u;
          }
        },
        watch: {
          activeCountry: function activeCountry(t, e) {
            t || null === e || void 0 === e || !e.iso2 || this.inputOptions.showDialCode ? null !== t && void 0 !== t && t.iso2 && this.$emit("country-changed", t) : this.activeCountryCode = e.iso2;
          },
          "phoneObject.countryCode": function phoneObjectCountryCode(t) {
            t && (this.activeCountryCode = t || "");
          },
          "phoneObject.valid": function phoneObjectValid() {
            this.$emit("validate", this.phoneObject);
          },
          "phoneObject.formatted": function phoneObjectFormatted(t) {
            var e = this;
            this.autoFormat && !this.customValidate && (this.emitInput(t), this.$nextTick(function () {
              t && !e.value && (e.phone = t);
            }));
          },
          "inputOptions.placeholder": function inputOptionsPlaceholder() {
            this.resetPlaceholder();
          },
          value: function value(t, e) {
            var n = this;
            this.testCharacters() ? this.phone = t : this.$nextTick(function () {
              n.phone = e, n.onInput();
            });
          },
          open: function open(t) {
            t ? (this.setDropdownPosition(), this.$emit("open")) : this.$emit("close");
          }
        },
        mounted: function mounted() {
          var t = this;
          this.value && (this.phone = this.value.trim()), this.cleanInvalidCharacters(), this.initializeCountry().then(function () {
            var e;
            !t.phone && null !== (e = t.inputOptions) && void 0 !== e && e.showDialCode && t.activeCountryCode && (t.phone = "+".concat(t.activeCountryCode)), t.$emit("validate", t.phoneObject);
          }).catch(console.error).then(function () {
            t.finishMounted = !0;
          });
        },
        methods: {
          resetPlaceholder: function resetPlaceholder() {
            this.parsedPlaceholder = this.inputOptions.placeholder;
          },
          initializeCountry: function initializeCountry() {
            var t = this;
            return new Promise(function (e) {
              var n;

              if ("+" !== (null === (n = t.phone) || void 0 === n ? void 0 : n[0])) {
                if (t.defaultCountry) {
                  if ("string" === typeof t.defaultCountry) return t.choose(t.defaultCountry), void e();

                  if ("number" === typeof t.defaultCountry) {
                    var r = t.findCountryByDialCode(t.defaultCountry);
                    if (r) return t.choose(r.iso2), void e();
                  }
                }

                var d = t.preferredCountries[0] || t.filteredCountries[0];
                t.autoDefaultCountry ? g().then(function (e) {
                  t.choose(e || t.activeCountryCode);
                }).catch(function (e) {
                  console.warn(e), t.choose(d);
                }).then(function () {
                  e();
                }) : (t.choose(d), e());
              } else e();
            });
          },
          getCountries: function getCountries() {
            var t = this,
                e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            return e.map(function (e) {
              return t.findCountry(e);
            }).filter(Boolean);
          },
          findCountry: function findCountry() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            return this.filteredCountries.find(function (e) {
              return e.iso2 === t.toUpperCase();
            });
          },
          findCountryByDialCode: function findCountryByDialCode(t) {
            return this.filteredCountries.find(function (e) {
              return Number(e.dialCode) === t;
            });
          },
          getItemClass: function getItemClass(t, e) {
            var n = this.selectedIndex === t,
                r = t === this.preferredCountries.length - 1,
                d = this.preferredCountries.some(function (t) {
              return t.toUpperCase() === e;
            });
            return {
              highlighted: n,
              "last-preferred": r,
              preferred: d
            };
          },
          choose: function choose(t) {
            var e,
                n,
                r = t;

            if ("string" === typeof r && (r = this.findCountry(r)), r) {
              if ("+" === (null === (e = this.phone) || void 0 === e ? void 0 : e[0]) && r.iso2 && this.phoneObject.nationalNumber) return this.activeCountryCode = r.iso2, void (this.phone = Ke(this.phoneObject.nationalNumber, r.iso2).formatInternational());
              if (null !== (n = this.inputOptions) && void 0 !== n && n.showDialCode && r) return this.phone = "+".concat(r.dialCode), void (this.activeCountryCode = r.iso2 || "");
              this.activeCountryCode = r.iso2 || "", this.emitInput(this.phone);
            }
          },
          cleanInvalidCharacters: function cleanInvalidCharacters() {
            var t = this.phone;

            if (this.validCharactersOnly) {
              var e = this.phone.match(/[()\-+0-9\s]*/g);
              this.phone = e.join("");
            }

            if (this.customValidate && this.customValidate instanceof RegExp) {
              var n = this.phone.match(this.customValidate);
              this.phone = n.join("");
            }

            t !== this.phone && this.emitInput(this.phone);
          },
          testCharacters: function testCharacters() {
            if (this.validCharactersOnly) {
              var t = /^[()\-+0-9\s]*$/.test(this.phone);
              if (!t) return !1;
            }

            return !this.customValidate || this.testCustomValidate();
          },
          testCustomValidate: function testCustomValidate() {
            return this.customValidate instanceof RegExp && this.customValidate.test(this.phone);
          },
          onInput: function onInput() {
            this.$refs.input.setCustomValidity(this.phoneObject.valid ? "" : this.invalidMsg), this.emitInput(this.phone);
          },
          emitInput: function emitInput(t) {
            this.$emit("input", t, this.phoneObject, this.$refs.input);
          },
          onBlur: function onBlur() {
            this.$emit("blur");
          },
          onFocus: function onFocus() {
            m(this.$refs.input, this.phone.length), this.$emit("focus");
          },
          onEnter: function onEnter() {
            this.$emit("enter");
          },
          onSpace: function onSpace() {
            this.$emit("space");
          },
          focus: function focus() {
            this.$refs.input.focus();
          },
          toggleDropdown: function toggleDropdown(t) {
            var e, n;
            this.disabled || this.dropdownOptions.disabled || "text" === (null === t || void 0 === t || null === (e = t.path) || void 0 === e || null === (n = e[0]) || void 0 === n ? void 0 : n.type) || (this.searchQuery = "", this.open = !this.open);
          },
          clickedOutside: function clickedOutside() {
            this.open = !1;
          },
          keyboardNav: function keyboardNav(t) {
            var e = this;

            if (40 === t.keyCode) {
              t.preventDefault(), this.open = !0, null === this.selectedIndex ? this.selectedIndex = 0 : this.selectedIndex = Math.min(this.sortedCountries.length - 1, this.selectedIndex + 1);
              var n = this.$refs.list.children[this.selectedIndex];
              n.focus(), n.offsetTop + n.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight && (this.$refs.list.scrollTop = n.offsetTop - this.$refs.list.clientHeight + n.clientHeight);
            } else if (38 === t.keyCode) {
              t.preventDefault(), this.open = !0, null === this.selectedIndex ? this.selectedIndex = this.sortedCountries.length - 1 : this.selectedIndex = Math.max(0, this.selectedIndex - 1);
              var r = this.$refs.list.children[this.selectedIndex];
              r.focus(), r.offsetTop < this.$refs.list.scrollTop && (this.$refs.list.scrollTop = r.offsetTop);
            } else if (13 === t.keyCode) null !== this.selectedIndex && this.choose(this.sortedCountries[this.selectedIndex]), this.open = !this.open;else {
              this.typeToFindInput += t.key, clearTimeout(this.typeToFindTimer), this.typeToFindTimer = setTimeout(function () {
                e.typeToFindInput = "";
              }, 700);
              var d = this.sortedCountries.slice(this.preferredCountries.length).findIndex(function (t) {
                return t.name.toLowerCase().startsWith(e.typeToFindInput);
              });

              if (d >= 0) {
                this.selectedIndex = this.preferredCountries.length + d;
                var i = this.$refs.list.children[this.selectedIndex],
                    o = i.offsetTop < this.$refs.list.scrollTop,
                    a = i.offsetTop + i.clientHeight > this.$refs.list.scrollTop + this.$refs.list.clientHeight;
                (o || a) && (this.$refs.list.scrollTop = i.offsetTop - this.$refs.list.clientHeight / 2);
              }
            }
          },
          reset: function reset() {
            this.selectedIndex = this.sortedCountries.map(function (t) {
              return t.iso2;
            }).indexOf(this.activeCountryCode), this.open = !1;
          },
          setDropdownPosition: function setDropdownPosition() {
            var t = window.innerHeight - this.$el.getBoundingClientRect().bottom,
                e = t > 200;
            this.dropdownOpenDirection = e ? "below" : "above";
          }
        }
      },
          qe = Ze;

      function Je(t, e, n, r, d, i, o, a) {
        var u,
            $ = "function" === typeof t ? t.options : t;
        if (e && ($.render = e, $.staticRenderFns = n, $._compiled = !0), r && ($.functional = !0), i && ($._scopeId = "data-v-" + i), o ? (u = function u(t) {
          t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" === typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), d && d.call(this, t), t && t._registeredComponents && t._registeredComponents.add(o);
        }, $._ssrRegister = u) : d && (u = a ? function () {
          d.call(this, ($.functional ? this.parent : this).$root.$options.shadowRoot);
        } : d), u) if ($.functional) {
          $._injectStyles = u;
          var c = $.render;

          $.render = function (t, e) {
            return u.call(e), c(t, e);
          };
        } else {
          var s = $.beforeCreate;
          $.beforeCreate = s ? [].concat(s, u) : [u];
        }
        return {
          exports: t,
          options: $
        };
      }

      var Xe = Je(qe, O, w, !1, null, null, null),
          Qe = Xe.exports,
          tn = ["dropdownOptions", "inputOptions"],
          en = ["dropdownOptions", "inputOptions"];

      function nn(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};

        if (!nn.installed) {
          nn.installed = !0;
          var n = e.dropdownOptions,
              r = e.inputOptions,
              d = $(e, tn),
              i = C.dropdownOptions,
              o = C.inputOptions,
              u = $(C, en);
          x.options = a(a({
            inputOptions: a(a({}, o), r),
            dropdownOptions: a(a({}, i), n)
          }, u), d), t.component("vue-tel-input", Qe);
        }
      }

      var rn = {
        install: nn
      },
          dn = null;
      "undefined" !== typeof window ? dn = window.Vue : "undefined" !== typeof n.g && (dn = n.g.Vue), dn && dn.use(rn);
      var on = rn,
          an = on;
    }(), r;
  }();
});